const exampleJson = {
  sections: [
    {
      id: "f35b05ada15c9662015bcfda495bd3f1a5377748",
      name: "Aphrodite",
      products: [
        {
          description:
            "<p>Aphrodite, Goddess of love invites you to celebrate your body and sensuality.</p>",
          ending_price_formatted: "$225",
          id: "7171313303604",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-aphrodite-necklace-31821018103860.webp?v=1720699751",
          link: "https://aweinspired.com/products/aphrodite-necklace",
          product_block_id: "f35b05ada15c9662015bcfda495bd3f1a5377748",
          starting_price_formatted: "$200",
          tags: [],
          title: "Aphrodite Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41347182723124",
              price: 215,
              price_formatted: "$215",
              title: "Aphrodite Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41347182788660",
              price: 200,
              price_formatted: "$200",
              title: "Aphrodite Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42050667053108",
              price: 225,
              price_formatted: "$225",
              title: "Aphrodite Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42050667085876",
              price: 215,
              price_formatted: "$215",
              title: "Aphrodite Necklace",
            },
          ],
        },
        {
          description:
            "<p>Aphrodite, Goddess of love invites you to celebrate your body and sensuality.</p>",
          ending_price_formatted: "$125",
          id: "6544676683828",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-aphrodite-signet-ring-30831711354932.jpg?v=1720700643",
          link: "https://aweinspired.com/products/aphrodite-signet-ring",
          product_block_id: "f35b05ada15c9662015bcfda495bd3f1a5377748",
          starting_price_formatted: "$95",
          tags: [],
          title: "Aphrodite Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231424847924",
              price: 125,
              price_formatted: "$125",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231424880692",
              price: 95,
              price_formatted: "$95",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231424978996",
              price: 125,
              price_formatted: "$125",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231425011764",
              price: 95,
              price_formatted: "$95",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231425110068",
              price: 125,
              price_formatted: "$125",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231425175604",
              price: 95,
              price_formatted: "$95",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231425273908",
              price: 125,
              price_formatted: "$125",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231425306676",
              price: 95,
              price_formatted: "$95",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231425404980",
              price: 125,
              price_formatted: "$125",
              title: "Aphrodite Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231425470516",
              price: 95,
              price_formatted: "$95",
              title: "Aphrodite Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "bb4af6b396550fda975942593a3c0ecec6df8c53",
      name: "Athena",
      products: [
        {
          description:
            "<p>Athena, Goddess of wisdom and knowledge, inspires greatness and courage within to succeed.</p>",
          ending_price_formatted: "$225",
          id: "7171319332916",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-athena-necklace-31251403112500.webp?v=1720639450",
          link: "https://aweinspired.com/products/athena-necklace",
          product_block_id: "bb4af6b396550fda975942593a3c0ecec6df8c53",
          starting_price_formatted: "$200",
          tags: [],
          title: "Athena Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41347213688884",
              price: 215,
              price_formatted: "$215",
              title: "Athena Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41347213754420",
              price: 200,
              price_formatted: "$200",
              title: "Athena Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42041948078132",
              price: 225,
              price_formatted: "$225",
              title: "Athena Necklace",
            },
            {
              compare_at_price: 210,
              compare_at_price_formatted: null,
              id: "42041948110900",
              price: 210,
              price_formatted: "$210",
              title: "Athena Necklace",
            },
          ],
        },
        {
          description:
            "<p>Athena, Goddess of wisdom and knowledge, inspires greatness and courage within to succeed.</p>",
          ending_price_formatted: "$125",
          id: "6544673374260",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-athena-signet-ring-30831482077236.jpg?v=1720740254",
          link: "https://aweinspired.com/products/athena-signet-ring",
          product_block_id: "bb4af6b396550fda975942593a3c0ecec6df8c53",
          starting_price_formatted: "$95",
          tags: [],
          title: "Athena Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 120,
              compare_at_price_formatted: null,
              id: "41231238692916",
              price: 120,
              price_formatted: "$120",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231238725684",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 120,
              compare_at_price_formatted: null,
              id: "41231238758452",
              price: 120,
              price_formatted: "$120",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231238791220",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 120,
              compare_at_price_formatted: null,
              id: "41231238889524",
              price: 120,
              price_formatted: "$120",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231238922292",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231239053364",
              price: 125,
              price_formatted: "$125",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231239086132",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231239184436",
              price: 125,
              price_formatted: "$125",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231239217204",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231239348276",
              price: 125,
              price_formatted: "$125",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231239381044",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231239479348",
              price: 125,
              price_formatted: "$125",
              title: "Athena Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231239512116",
              price: 95,
              price_formatted: "$95",
              title: "Athena Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "d509625321dd0b5a36912032a3911afadb0453f3",
      name: "Freya",
      products: [
        {
          description:
            "<p>Freya, goddess of fertility. This Goddess brings your feminine energy to the forefront.</p>",
          ending_price_formatted: "$225",
          id: "7173373689908",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-freya-necklace-30984340635700.jpg?v=1720640892",
          link: "https://aweinspired.com/products/freya-necklace",
          product_block_id: "d509625321dd0b5a36912032a3911afadb0453f3",
          starting_price_formatted: "$200",
          tags: [],
          title: "Freya Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41357220839476",
              price: 215,
              price_formatted: "$215",
              title: "Freya Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41357220872244",
              price: 200,
              price_formatted: "$200",
              title: "Freya Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42051723132980",
              price: 225,
              price_formatted: "$225",
              title: "Freya Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42051723231284",
              price: 215,
              price_formatted: "$215",
              title: "Freya Necklace",
            },
          ],
        },
        {
          description:
            "<p>Freya, goddess of fertility. This Goddess brings your feminine energy to the forefront.</p>",
          ending_price_formatted: "$160",
          id: "6654545690676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-freya-pendant-30831597518900.jpg?v=1720784163",
          link: "https://aweinspired.com/products/freya-pendant-necklace-14k-gold-vermeil",
          product_block_id: "d509625321dd0b5a36912032a3911afadb0453f3",
          starting_price_formatted: "$150",
          tags: [],
          title: "Freya Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231330541620",
              price: 160,
              price_formatted: "$160",
              title: "Freya Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231330574388",
              price: 150,
              price_formatted: "$150",
              title: "Freya Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "a2fd72c240e2713ddb9da35acdb9bcc767724a44",
      name: "Hecate",
      products: [
        {
          description:
            "<p>Channel your inner magic and mystique with Hecate, Goddess of Witchcraft.</p>",
          ending_price_formatted: "$225",
          id: "7173353603124",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-greek-goddess-coin-necklace-30964455243828.webp?v=1720779321",
          link: "https://aweinspired.com/products/hecate-necklace",
          product_block_id: "a2fd72c240e2713ddb9da35acdb9bcc767724a44",
          starting_price_formatted: "$200",
          tags: [],
          title: "Hecate Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41357108510772",
              price: 215,
              price_formatted: "$215",
              title: "Hecate Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41357108576308",
              price: 200,
              price_formatted: "$200",
              title: "Hecate Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42050789310516",
              price: 225,
              price_formatted: "$225",
              title: "Hecate Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42050789343284",
              price: 215,
              price_formatted: "$215",
              title: "Hecate Necklace",
            },
          ],
        },
        {
          description:
            "<p>Channel your inner magic and mystique with Hecate, Goddess of Witchcraft.</p>",
          id: "6574739062836",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-hecate-signet-ring-30831586246708.jpg?v=1720792096",
          link: "https://aweinspired.com/products/hecate-signet-ring",
          price: 125,
          price_formatted: "$125",
          product_block_id: "a2fd72c240e2713ddb9da35acdb9bcc767724a44",
          tags: [],
          title: "Hecate Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231317827636",
              price: 125,
              price_formatted: "$125",
              title: "Hecate Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "606793a89ca08d47ff7bf5d3cc5804af16e4a28c",
      name: "Isis",
      products: [
        {
          description:
            "<p>In ancient Egypt, Goddess Isis was often depicted holding an ankh to a person’s lips to revive their soul and give them eternal life. Thus, many believe the ankh symbolizes mortality and the afterlife simultaneously. This Ankh of Isis Amulet is a powerful reminder to live in the moment and not fear the unknown or unexplained.</p>",
          ending_price_formatted: "$165",
          id: "7175138607156",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-ankh-of-isis-necklace-31280133537844.webp?v=1720702992",
          link: "https://aweinspired.com/products/ankh-of-isis-necklace",
          product_block_id: "606793a89ca08d47ff7bf5d3cc5804af16e4a28c",
          starting_price_formatted: "$140",
          tags: [],
          title: "Ankh of Isis Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 155,
              compare_at_price_formatted: null,
              id: "41366562963508",
              price: 155,
              price_formatted: "$155",
              title: "Ankh of Isis Necklace",
            },
            {
              compare_at_price: 140,
              compare_at_price_formatted: null,
              id: "41366562996276",
              price: 140,
              price_formatted: "$140",
              title: "Ankh of Isis Necklace",
            },
            {
              compare_at_price: 155,
              compare_at_price_formatted: null,
              id: "42033113628724",
              price: 165,
              price_formatted: "$165",
              title: "Ankh of Isis Necklace",
            },
            {
              compare_at_price: 155,
              compare_at_price_formatted: null,
              id: "42033113661492",
              price: 150,
              price_formatted: "$150",
              title: "Ankh of Isis Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "37d55f207e16f14c73fa679fb2f8e789a3d3aa30",
      name: "Lilith",
      products: [
        {
          description:
            "<p>Long ago, Lilith was Adam’s first wife in the Garden of Eden. When she refused to submit to his desires, she was banished, demonized and called a succubus. Denying his power, Lilith only grew stronger, rising from the ashes with a powerful vengeance and a burning desire. Under her protection, women walk free of shame.</p>\n<p>Wear Lilith to take your power back. This intricate depiction features Lilith’s open wings as she reigns under the black moon, empowering you to reclaim your rights, burn all that does not serve you, and set you free to explore the dark side. This Special Edition Lilith Necklace is cast in 14k gold vermeil and sits on a slice of mother of pearl that shines through to add a shadowy reflection against her form. Her fluted spikes adorn a coin edge and spiked prongs hold her safely in place.</p>\n<p>Crowned in moonlight, Lilith wears Awe Inspired — this most intricate detailing reveals that she holds her Black Moon sigil and the Awe Inspired Triple Moon, while she wears our Crescent Moon Amulet. Our fascination with the smallest details and desire to adorn every Goddess prompts this revelation: your jewelry wears jewelry.</p>",
          ending_price_formatted: "$265",
          id: "7291353825332",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-special-edition-lilith-20-22-box-chain-special-edition-goddess-necklace-31666532909108.webp?v=1720682294",
          link: "https://aweinspired.com/products/special-edition-lilith-necklace",
          product_block_id: "37d55f207e16f14c73fa679fb2f8e789a3d3aa30",
          starting_price_formatted: "$225",
          tags: [],
          title: "Special Edition Lilith Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 255,
              compare_at_price_formatted: null,
              id: "42718085513268",
              price: 255,
              price_formatted: "$255",
              title: "Special Edition Lilith Necklace",
            },
            {
              compare_at_price: 265,
              compare_at_price_formatted: null,
              id: "42764555386932",
              price: 265,
              price_formatted: "$265",
              title: "Special Edition Lilith Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42793394438196",
              price: 225,
              price_formatted: "$225",
              title: "Special Edition Lilith Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42793394470964",
              price: 235,
              price_formatted: "$235",
              title: "Special Edition Lilith Necklace",
            },
          ],
        },
        {
          description:
            "<p>Long ago, Lilith was Adam’s first wife in the Garden of Eden. When she refused to submit to his desires, she was banished, demonized and called a succubus. Denying his power, Lilith only grew stronger, rising from the ashes with a powerful vengeance and a burning desire. Under her protection, women walk free of shame.</p>\n<p>Wear Lilith to take your power back. This intricate depiction features Lilith’s open wings as she reigns under the black moon, empowering you to reclaim your rights, burn all that does not serve you, and set you free to explore the dark side.</p>\n<p>This vintage setting, wide band signet ring features most intricate detailing. Crowned in moonlight, Lilith holds her Black Moon sigil and the Awe Inspired Triple Moon, while she wears our Crescent Moon Amulet. Our fascination with the smallest details and desire to adorn every Goddess prompts this revelation: your jewelry wears jewelry.</p>",
          ending_price_formatted: "$195",
          id: "7289633964084",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-lilith-signet-ring-31675705917492.webp?v=1720814582",
          link: "https://aweinspired.com/products/lilith-ring",
          product_block_id: "37d55f207e16f14c73fa679fb2f8e789a3d3aa30",
          starting_price_formatted: "$175",
          tags: [],
          title: "Lilith Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548001844",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548034612",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548132916",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548165684",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548198452",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548231220",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548263988",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548296756",
              price: 195,
              price_formatted: "$195",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548329524",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548362292",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548395060",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548427828",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548460596",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
            {
              compare_at_price: null,
              compare_at_price_formatted: null,
              id: "42692548493364",
              price: 175,
              price_formatted: "$175",
              title: "Lilith Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "7bb2152395e335c5f7ef7e251c3fef57086d915e",
      name: "Medusa",
      products: [
        {
          description:
            "<p>A storied symbol of protection and strength, let Medusa be a reminder of your resilience.</p>",
          ending_price_formatted: "$225",
          id: "7171965550644",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-greek-goddess-coin-necklace-31250761973812.webp?v=1720785569",
          link: "https://aweinspired.com/products/medusa-necklace",
          product_block_id: "7bb2152395e335c5f7ef7e251c3fef57086d915e",
          starting_price_formatted: "$200",
          tags: [],
          title: "Medusa Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41350166446132",
              price: 215,
              price_formatted: "$215",
              title: "Medusa Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41350166511668",
              price: 200,
              price_formatted: "$200",
              title: "Medusa Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42051807281204",
              price: 225,
              price_formatted: "$225",
              title: "Medusa Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42051807313972",
              price: 215,
              price_formatted: "$215",
              title: "Medusa Necklace",
            },
          ],
        },
        {
          description:
            "<p>A storied symbol of protection and strength, let Medusa be a reminder of your resilience.</p>",
          ending_price_formatted: "$125",
          id: "6544674816052",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-medusa-goddess-signet-ring-30831581331508.jpg?v=1720757185",
          link: "https://aweinspired.com/products/medusa-signet-ring",
          product_block_id: "7bb2152395e335c5f7ef7e251c3fef57086d915e",
          starting_price_formatted: "$95",
          tags: [],
          title: "Medusa Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311077428",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231311142964",
              price: 95,
              price_formatted: "$95",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311208500",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231311274036",
              price: 95,
              price_formatted: "$95",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311405108",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231311437876",
              price: 95,
              price_formatted: "$95",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311601716",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311667252",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231311700020",
              price: 95,
              price_formatted: "$95",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311798324",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231311863860",
              price: 95,
              price_formatted: "$95",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231311994932",
              price: 125,
              price_formatted: "$125",
              title: "Medusa Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231312027700",
              price: 95,
              price_formatted: "$95",
              title: "Medusa Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "c6e2aa57d229ee12384fae582310bd82ef417ab2",
      name: "Persephone",
      products: [
        {
          description:
            "<p>Celebrate your duality with Persephone, the Queen of the Underworld and Goddess of springtime. You too can be both.</p>",
          ending_price_formatted: "$225",
          id: "7171988488244",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-persephone-necklace-31820999983156.webp?v=1720887488",
          link: "https://aweinspired.com/products/persephone-necklace",
          product_block_id: "c6e2aa57d229ee12384fae582310bd82ef417ab2",
          starting_price_formatted: "$200",
          tags: [],
          title: "Persephone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41350244761652",
              price: 215,
              price_formatted: "$215",
              title: "Persephone Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41350244827188",
              price: 200,
              price_formatted: "$200",
              title: "Persephone Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42053811896372",
              price: 225,
              price_formatted: "$225",
              title: "Persephone Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42053811961908",
              price: 215,
              price_formatted: "$215",
              title: "Persephone Necklace",
            },
          ],
        },
        {
          description:
            "<p>Celebrate your duality with Persephone, the Queen of the Underworld and Goddess of Springtime. You too can be both.</p>",
          ending_price_formatted: "$100",
          id: "6557185802292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-persephone-goddess-signet-ring-30831590932532.jpg?v=1720785574",
          link: "https://aweinspired.com/products/persephone-signet-ring",
          product_block_id: "c6e2aa57d229ee12384fae582310bd82ef417ab2",
          starting_price_formatted: "$76",
          tags: [],
          title: "Persephone Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231321432116",
              price: 100,
              price_formatted: "$100",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231321464884",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231321497652",
              price: 100,
              price_formatted: "$100",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231321530420",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231321661492",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231321759796",
              price: 100,
              price_formatted: "$100",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231321792564",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231321890868",
              price: 100,
              price_formatted: "$100",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231321923636",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231322021940",
              price: 100,
              price_formatted: "$100",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231322054708",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231322153012",
              price: 100,
              price_formatted: "$100",
              title: "Persephone Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231322185780",
              price: 76,
              price_formatted: "$76",
              title: "Persephone Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "48418164b021d3a92b1fce45cc7a8ae7451db5ef",
      name: "Mother Earth",
      products: [
        {
          description:
            "<p>Cradling the blue opal Earth to her body, Mother Earth’s lustrous hair falls in waves against sun rays, cut out to show the glowing slice of white mother of pearl inlaid on the back of the pendant. Haloed in white topaz, this piece is slightly larger than our average Goddess pendant.</p>\n<p>Blue opal is a gemstone of healing and promise, signifying the hope of revival and the power we have to heal the earth. The soft, glowing rays of mother of pearl bring healing light to your inner world as well, so Mother Earth may nurture you as she does all life on Earth.</p>\n<p>Awe Inspired is proud to donate proceeds of the Mother Earth Necklace to the Women’s Earth Alliance, a charity that provides grants to women conducting sustainability projects all over the world, empowering women’s leadership and helping to end the climate crisis and protect the environment.</p>",
          ending_price_formatted: "$320",
          id: "7363105128500",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-box-chain-mother-earth-goddess-necklace-31835016233012.webp?v=1720872184",
          link: "https://aweinspired.com/products/mother-earth-goddess-necklace",
          product_block_id: "48418164b021d3a92b1fce45cc7a8ae7451db5ef",
          starting_price_formatted: "$280",
          tags: [],
          title: "Mother Earth Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 310,
              compare_at_price_formatted: null,
              id: "43161208094772",
              price: 310,
              price_formatted: "$310",
              title: "Mother Earth Goddess Necklace",
            },
            {
              compare_at_price: 280,
              compare_at_price_formatted: null,
              id: "43161208127540",
              price: 280,
              price_formatted: "$280",
              title: "Mother Earth Goddess Necklace",
            },
            {
              compare_at_price: 320,
              compare_at_price_formatted: null,
              id: "43161208487988",
              price: 320,
              price_formatted: "$320",
              title: "Mother Earth Goddess Necklace",
            },
            {
              compare_at_price: 290,
              compare_at_price_formatted: null,
              id: "43161208520756",
              price: 290,
              price_formatted: "$290",
              title: "Mother Earth Goddess Necklace",
            },
          ],
        },
        {
          description:
            "<p>Pachamama “Mother Earth” honors this Andean Earth Goddess who takes care of all living things.</p>",
          ending_price_formatted: "$180",
          id: "7242674274356",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-standard-mother-earth-necklace-31327082905652.webp?v=1720868958",
          link: "https://aweinspired.com/products/mother-earth-necklace",
          product_block_id: "48418164b021d3a92b1fce45cc7a8ae7451db5ef",
          starting_price_formatted: "$172",
          tags: [],
          title: "Mother Earth Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42208320913460",
              price: 172,
              price_formatted: "$172",
              title: "Mother Earth Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42208325271604",
              price: 180,
              price_formatted: "$180",
              title: "Mother Earth Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "8c8548ec2edf3a0826443a4b8c32b0814405b687",
      name: "Selene",
      products: [
        {
          description:
            "<p>Selene, Goddess of the moon. She'll connect you to the mystical power of the moon.</p>",
          ending_price_formatted: "$215",
          id: "7173358288948",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-selene-necklace-31001115983924.webp?v=1720893797",
          link: "https://aweinspired.com/products/selene-necklace",
          product_block_id: "8c8548ec2edf3a0826443a4b8c32b0814405b687",
          starting_price_formatted: "$200",
          tags: [],
          title: "Selene Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41357143277620",
              price: 215,
              price_formatted: "$215",
              title: "Selene Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41357143343156",
              price: 200,
              price_formatted: "$200",
              title: "Selene Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42050780594228",
              price: 215,
              price_formatted: "$215",
              title: "Selene Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42050780692532",
              price: 215,
              price_formatted: "$215",
              title: "Selene Necklace",
            },
          ],
        },
        {
          description:
            "<p>Selene, goddess of the moon. She'll connect you to the mystical power of the moon.</p>",
          ending_price_formatted: "$125",
          id: "6574738079796",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-selene-goddess-signet-ring-30831585656884.jpg?v=1720805768",
          link: "https://aweinspired.com/products/selene-signet-ring",
          product_block_id: "8c8548ec2edf3a0826443a4b8c32b0814405b687",
          starting_price_formatted: "$95",
          tags: [],
          title: "Selene Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231316516916",
              price: 125,
              price_formatted: "$125",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231316549684",
              price: 95,
              price_formatted: "$95",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231316582452",
              price: 125,
              price_formatted: "$125",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231316615220",
              price: 95,
              price_formatted: "$95",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231316647988",
              price: 125,
              price_formatted: "$125",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231316680756",
              price: 95,
              price_formatted: "$95",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231316746292",
              price: 95,
              price_formatted: "$95",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231316779060",
              price: 125,
              price_formatted: "$125",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231316811828",
              price: 95,
              price_formatted: "$95",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231316844596",
              price: 125,
              price_formatted: "$125",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231316877364",
              price: 95,
              price_formatted: "$95",
              title: "Selene Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231316975668",
              price: 125,
              price_formatted: "$125",
              title: "Selene Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "a7fcfbb47c65e299f5374d60cfc6e676a9f1a53c",
      name: "Brigid",
      products: [
        {
          description:
            "<p>Brigid, the triple deity. This pendant will help spark your creativity and drive.</p>",
          ending_price_formatted: "$203",
          id: "7173374083124",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-brigid-necklace-31250795954228.webp?v=1720737364",
          link: "https://aweinspired.com/products/brigid-necklace",
          product_block_id: "a7fcfbb47c65e299f5374d60cfc6e676a9f1a53c",
          starting_price_formatted: "$175",
          tags: [],
          title: "Brigid Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41357221363764",
              price: 193,
              price_formatted: "$193",
              title: "Brigid Necklace",
            },
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "41357221429300",
              price: 175,
              price_formatted: "$175",
              title: "Brigid Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42051713728564",
              price: 203,
              price_formatted: "$203",
              title: "Brigid Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42051713794100",
              price: 185,
              price_formatted: "$185",
              title: "Brigid Necklace",
            },
          ],
        },
        {
          description:
            "<p>Brigid, the triple deity. This pendant will help spark your creativity and drive.</p>",
          ending_price_formatted: "$128",
          id: "6705822105652",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-brigid-pendant-30909207478324.webp?v=1720740430",
          link: "https://aweinspired.com/products/brigid-necklace-14k-yellow-gold-vermeil",
          product_block_id: "a7fcfbb47c65e299f5374d60cfc6e676a9f1a53c",
          starting_price_formatted: "$120",
          tags: [],
          title: "Brigid Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231428255796",
              price: 128,
              price_formatted: "$128",
              title: "Brigid Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231428288564",
              price: 120,
              price_formatted: "$120",
              title: "Brigid Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "32a0c0388bf674710a29b2570f70ac47f8525c0e",
      name: "The Morrigan",
      products: [
        {
          description:
            "<p>The Morrigan, goddess of war. This pendant will call forth great reserves of strength.</p>",
          ending_price_formatted: "$168",
          id: "7173376081972",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-the-morrigan-16-18-celtic-goddess-coin-necklace-31250778587188.webp?v=1720744583",
          link: "https://aweinspired.com/products/the-morrigan-necklace",
          product_block_id: "32a0c0388bf674710a29b2570f70ac47f8525c0e",
          starting_price_formatted: "$158",
          tags: [],
          title: "The Morrigan Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "41357239517236",
              price: 158,
              price_formatted: "$158",
              title: "The Morrigan Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42052115071028",
              price: 168,
              price_formatted: "$168",
              title: "The Morrigan Necklace",
            },
          ],
        },
        {
          description:
            "<p>The Morrigan, goddess of war. This pendant will call forth great reserves of strength.</p>",
          id: "6705822826548",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-the-morrigan-pendant-30929165647924.webp?v=1720668979",
          link: "https://aweinspired.com/products/morrigan-necklace-14k-yellow-gold-vermeil",
          price: 103,
          price_formatted: "$103",
          product_block_id: "32a0c0388bf674710a29b2570f70ac47f8525c0e",
          tags: [],
          title: "The Morrigan Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231428550708",
              price: 103,
              price_formatted: "$103",
              title: "The Morrigan Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "09437606ac4b6a3e5a8704659c1dbeb2d3591daf",
      name: "Bastet",
      products: [
        {
          description:
            "<p>Bastet, often depicted as a woman with the head of a cat, is considered the great protectress in Egyptian mythology.</p>",
          ending_price_formatted: "$230",
          id: "7175138639924",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-bastet-necklace-31250793791540.webp?v=1720737911",
          link: "https://aweinspired.com/products/bastet-necklace",
          product_block_id: "09437606ac4b6a3e5a8704659c1dbeb2d3591daf",
          starting_price_formatted: "$200",
          tags: [],
          title: "Bastet Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 220,
              compare_at_price_formatted: null,
              id: "41366563029044",
              price: 220,
              price_formatted: "$220",
              title: "Bastet Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41366563061812",
              price: 200,
              price_formatted: "$200",
              title: "Bastet Necklace",
            },
            {
              compare_at_price: 230,
              compare_at_price_formatted: null,
              id: "42041952698420",
              price: 230,
              price_formatted: "$230",
              title: "Bastet Necklace",
            },
            {
              compare_at_price: 220,
              compare_at_price_formatted: null,
              id: "42041952731188",
              price: 220,
              price_formatted: "$220",
              title: "Bastet Necklace",
            },
          ],
        },
        {
          description:
            "<p>Bastet, often depicted as a woman with the head of a cat, is considered the great protectress in Egyptian mythology.</p>",
          ending_price_formatted: "$165",
          id: "6952086405172",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-bastet-tablet-30909205610548.webp?v=1720735944",
          link: "https://aweinspired.com/products/bastet-tablet",
          product_block_id: "09437606ac4b6a3e5a8704659c1dbeb2d3591daf",
          starting_price_formatted: "$150",
          tags: [],
          title: "Bastet Tablet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 165,
              compare_at_price_formatted: null,
              id: "41231352463412",
              price: 165,
              price_formatted: "$165",
              title: "Bastet Tablet",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231352528948",
              price: 150,
              price_formatted: "$150",
              title: "Bastet Tablet",
            },
          ],
        },
      ],
    },
    {
      id: "01650319b7b2d5939b6a57365e491c5b6c7f325a",
      name: "Guadalupe",
      products: [
        {
          description:
            "<p>In a series of five apparitions, the Virgin de Guadalupe appeared before Mexican peasant Juan Diego and his uncle Juan Bernardino, proving through the miraculous curing of Juan Bernardino that she was in fact the Virgin Mary. Since then, she has become a deeply important religious symbol in Mexico. In fact, her basilica in Mexico City is the most visited Catholic shrine in the world. When you’re looked after by the Virgin de Guadalupe, you will become the recipient of good health, good fortune, blessings, and abundance.</p>",
          ending_price_formatted: "$207",
          id: "7175139360820",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-virgen-de-guadalupe-necklace-30982256197684.jpg?v=1720659786",
          link: "https://aweinspired.com/products/virgen-de-guadalupe-necklace",
          product_block_id: "01650319b7b2d5939b6a57365e491c5b6c7f325a",
          starting_price_formatted: "$179",
          tags: [],
          title: "Virgen de Guadalupe Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 210,
              compare_at_price_formatted: null,
              id: "41366565322804",
              price: 179,
              price_formatted: "$179",
              title: "Virgen de Guadalupe Necklace",
            },
            {
              compare_at_price: 230,
              compare_at_price_formatted: null,
              id: "41366565355572",
              price: 197,
              price_formatted: "$197",
              title: "Virgen de Guadalupe Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "42044272312372",
              price: 207,
              price_formatted: "$207",
              title: "Virgen de Guadalupe Necklace",
            },
            {
              compare_at_price: 220,
              compare_at_price_formatted: null,
              id: "42044272345140",
              price: 189,
              price_formatted: "$189",
              title: "Virgen de Guadalupe Necklace",
            },
          ],
        },
        {
          description:
            "<p>In a series of five apparitions, the Virgin de Guadalupe appeared before Mexican peasant Juan Diego and his uncle Juan Bernardino, proving through the miraculous curing of Juan Bernardino that she was in fact the Virgin Mary. Since then, she has become a deeply important religious symbol in Mexico. In fact, her basilica in Mexico City is the most visited Catholic shrine in the world. When you’re looked after by the Virgin de Guadalupe, you will become the recipient of good health, good fortune, blessings, and abundance.</p>",
          ending_price_formatted: "$132",
          id: "7036590948404",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-virgen-de-guadalupe-pendant-30831637758004.jpg?v=1720659971",
          link: "https://aweinspired.com/products/virgen-de-guadalupe-pendant",
          product_block_id: "01650319b7b2d5939b6a57365e491c5b6c7f325a",
          starting_price_formatted: "$124",
          tags: [],
          title: "Virgen de Guadalupe Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 165,
              compare_at_price_formatted: null,
              id: "41231366848564",
              price: 132,
              price_formatted: "$132",
              title: "Virgen de Guadalupe Pendant",
            },
            {
              compare_at_price: 155,
              compare_at_price_formatted: null,
              id: "41231366881332",
              price: 124,
              price_formatted: "$124",
              title: "Virgen de Guadalupe Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "643638b5c06f3451a48a0fa41ee5673721a96263",
      name: "Asteria - NO PRODUCT",
      products: [],
    },
    {
      id: "23d9b77db05b5fdcf2e76b2407be8bcb4eec68f8",
      name: "Psyche - NO PRODUCT",
      products: [],
    },
    {
      id: "283bed443d21d5d14e958b85a383e6e5da2f739a",
      name: "Lady Buddha - NO PRODUCT",
      products: [],
    },
    {
      id: "2537c3935383d1106779c22e124140e5c5ae348d",
      name: "Rhiannon",
      products: [
        {
          description:
            "<p>Rhiannon, the enchantress. This Goddess was made for lovers of nature and beauty.</p>",
          ending_price_formatted: "$225",
          id: "7173374902324",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-rhiannon-necklace-31939626663988.webp?v=1720698859",
          link: "https://aweinspired.com/products/rhiannon-necklace",
          product_block_id: "2537c3935383d1106779c22e124140e5c5ae348d",
          starting_price_formatted: "$200",
          tags: [],
          title: "Rhiannon Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41357230964788",
              price: 215,
              price_formatted: "$215",
              title: "Rhiannon Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41357231030324",
              price: 200,
              price_formatted: "$200",
              title: "Rhiannon Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42052109271092",
              price: 225,
              price_formatted: "$225",
              title: "Rhiannon Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42052109303860",
              price: 215,
              price_formatted: "$215",
              title: "Rhiannon Necklace",
            },
          ],
        },
        {
          description:
            '<p><meta charset="utf-8"><span data-mce-fragment="1">Rhiannon is a Goddess of rebirth, creativity, overcoming adversity and the natural beauty and power of femininity.</span> <strong>﻿100% of proceeds to go MS Association of America in honor of Christina Applegate. </strong></p>',
          ending_price_formatted: "$160",
          id: "6705821351988",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-rhiannon-pendant-30909231300660.webp?v=1720852204",
          link: "https://aweinspired.com/products/rhiannon-necklace-14k-yellow-gold-vermeil",
          product_block_id: "2537c3935383d1106779c22e124140e5c5ae348d",
          starting_price_formatted: "$150",
          tags: [],
          title: "Rhiannon Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231405252660",
              price: 160,
              price_formatted: "$160",
              title: "Rhiannon Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231405285428",
              price: 150,
              price_formatted: "$150",
              title: "Rhiannon Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "b31eaae76601630d64376b446461e84617d14197",
      name: "Oshun",
      products: [
        {
          description:
            "<p>This Oshun Goddess will help you gather the strength and courage to make all your wishes come true.</p>",
          ending_price_formatted: "$180",
          id: "7244709953588",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-standard-16-18-oshun-necklace-31342487142452.webp?v=1720881903",
          link: "https://aweinspired.com/products/oshun-necklace",
          product_block_id: "b31eaae76601630d64376b446461e84617d14197",
          starting_price_formatted: "$172",
          tags: [],
          title: "Oshun Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42232145608756",
              price: 172,
              price_formatted: "$172",
              title: "Oshun Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42232161697844",
              price: 180,
              price_formatted: "$180",
              title: "Oshun Necklace",
            },
          ],
        },
        {
          description:
            "<p>This Oshun Goddess will help you gather the strength and courage to make all your wishes come true.</p>",
          id: "4856215994420",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-sterling-silver-standard-oshun-tablet-30831576776756.jpg?v=1720881727",
          link: "https://aweinspired.com/products/oshun-tablet-necklace",
          price: 120,
          price_formatted: "$120",
          product_block_id: "b31eaae76601630d64376b446461e84617d14197",
          tags: [],
          title: "Oshun Tablet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231309209652",
              price: 120,
              price_formatted: "$120",
              title: "Oshun Tablet",
            },
          ],
        },
      ],
    },
    {
      id: "17e59da6591260af30bd452fe8d8253f62450190",
      name: "Nemesis",
      products: [
        {
          description:
            "<p>As the Goddess of divine retribution, Nemesis delivers punishment for evil deeds, undeserved good fortune, and hubris.<br></p>",
          ending_price_formatted: "$170",
          id: "7237015699508",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-nemesis-necklace-31279918874676.webp?v=1720874702",
          link: "https://aweinspired.com/products/nemesis-necklace",
          product_block_id: "17e59da6591260af30bd452fe8d8253f62450190",
          starting_price_formatted: "$112",
          tags: [],
          title: "Nemesis Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42120850833460",
              price: 112,
              price_formatted: "$112",
              title: "Nemesis Necklace",
            },
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "42120850866228",
              price: 150,
              price_formatted: "$150",
              title: "Nemesis Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42120856207412",
              price: 170,
              price_formatted: "$170",
              title: "Nemesis Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42120856240180",
              price: 160,
              price_formatted: "$160",
              title: "Nemesis Necklace",
            },
          ],
        },
        {
          description:
            "<p>As the Goddess of divine retribution, Nemesis delivers punishment for evil deeds, undeserved good fortune, and hubris.</p>",
          ending_price_formatted: "$90",
          id: "7129182470196",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-nemesis-pendant-30857431121972.webp?v=1720873263",
          link: "https://aweinspired.com/products/nemesis-pendant",
          product_block_id: "17e59da6591260af30bd452fe8d8253f62450190",
          starting_price_formatted: "$80",
          tags: [],
          title: "Nemesis Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41247204474932",
              price: 90,
              price_formatted: "$90",
              title: "Nemesis Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41247204540468",
              price: 80,
              price_formatted: "$80",
              title: "Nemesis Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "ba1c16195aa64a06097a9d4e3391de9545d8e7a5",
      name: "Hermaphroditus",
      products: [
        {
          description:
            "<p>Goddess Hermaphroditus is proud to live beyond the typical, with no boundaries or restrictions in place.</p>",
          ending_price_formatted: "$203",
          id: "7173857542196",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-hermaphroditus-necklace-31247764357172.webp?v=1720783634",
          link: "https://aweinspired.com/products/hermaphroditus-necklace",
          product_block_id: "ba1c16195aa64a06097a9d4e3391de9545d8e7a5",
          starting_price_formatted: "$175",
          tags: [],
          title: "Hermaphroditus Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41359528001588",
              price: 193,
              price_formatted: "$193",
              title: "Hermaphroditus Necklace",
            },
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "41359528034356",
              price: 175,
              price_formatted: "$175",
              title: "Hermaphroditus Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42043239923764",
              price: 203,
              price_formatted: "$203",
              title: "Hermaphroditus Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42043239956532",
              price: 185,
              price_formatted: "$185",
              title: "Hermaphroditus Necklace",
            },
          ],
        },
        {
          description:
            "<p>Goddess Hermaphroditus is proud to live beyond the typical, with no boundaries or restrictions in place.</p>",
          ending_price_formatted: "$128",
          id: "6825248489524",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-hermaphroditus-pendant-31248256565300.webp?v=1720791912",
          link: "https://aweinspired.com/products/hermaphroditus-necklace-14k-yellow-gold-vermeil",
          product_block_id: "ba1c16195aa64a06097a9d4e3391de9545d8e7a5",
          starting_price_formatted: "$120",
          tags: [],
          title: "Hermaphroditus Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231356952628",
              price: 128,
              price_formatted: "$128",
              title: "Hermaphroditus Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231356985396",
              price: 120,
              price_formatted: "$120",
              title: "Hermaphroditus Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "ca6e1bad2e79bf08520a4d90096b77d6623838df",
      name: "Fortuna",
      products: [
        {
          description:
            "<p>Fortuna, Goddess of good fortune. Fortuna will bring you good luck and glorious prosperity.</p>",
          ending_price_formatted: "$235",
          id: "7175139557428",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-fortuna-necklace-30982246662196.jpg?v=1720773549",
          link: "https://aweinspired.com/products/fortuna-necklace",
          product_block_id: "ca6e1bad2e79bf08520a4d90096b77d6623838df",
          starting_price_formatted: "$210",
          tags: [],
          title: "Fortuna Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41366565748788",
              price: 225,
              price_formatted: "$225",
              title: "Fortuna Necklace",
            },
            {
              compare_at_price: 210,
              compare_at_price_formatted: null,
              id: "41366565781556",
              price: 210,
              price_formatted: "$210",
              title: "Fortuna Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42052152918068",
              price: 235,
              price_formatted: "$235",
              title: "Fortuna Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42052152950836",
              price: 220,
              price_formatted: "$220",
              title: "Fortuna Necklace",
            },
          ],
        },
        {
          description:
            "<p>Fortuna, Goddess of good fortune. Fortuna will bring you good luck and glorious prosperity.</p>",
          ending_price_formatted: "$160",
          id: "7052452855860",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-fortuna-pendant-30831640477748.jpg?v=1720775711",
          link: "https://aweinspired.com/products/fortuna-pendant",
          product_block_id: "ca6e1bad2e79bf08520a4d90096b77d6623838df",
          starting_price_formatted: "$150",
          tags: [],
          title: "Fortuna Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231367864372",
              price: 160,
              price_formatted: "$160",
              title: "Fortuna Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231367897140",
              price: 150,
              price_formatted: "$150",
              title: "Fortuna Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "d02844324b75e29a7bc7e0940ecb5a61651b36fd",
      name: "Artemis",
      products: [
        {
          description:
            '<span data-mce-fragment="1">Artemis, the independent protector, encourages you to unleash your wild side.</span>',
          ending_price_formatted: "$225",
          id: "7128053186612",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-artemis-necklace-30849629159476.webp?v=1720733588",
          link: "https://aweinspired.com/products/artemis-necklace",
          product_block_id: "d02844324b75e29a7bc7e0940ecb5a61651b36fd",
          starting_price_formatted: "$200",
          tags: [],
          title: "Artemis Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41241555435572",
              price: 215,
              price_formatted: "$215",
              title: "Artemis Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41241555501108",
              price: 200,
              price_formatted: "$200",
              title: "Artemis Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42041859342388",
              price: 225,
              price_formatted: "$225",
              title: "Artemis Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42041859375156",
              price: 210,
              price_formatted: "$210",
              title: "Artemis Necklace",
            },
          ],
        },
        {
          description:
            "<p>Artemis, the independent protector, encourages you to unleash your wild side.</p>",
          ending_price_formatted: "$160",
          id: "4506589265972",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-artemis-pendant-30835452215348.webp?v=1720732880",
          link: "https://aweinspired.com/products/artemis-coin-necklace-14k-yellow-gold-vermeil",
          product_block_id: "d02844324b75e29a7bc7e0940ecb5a61651b36fd",
          starting_price_formatted: "$150",
          tags: [],
          title: "Artemis Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231308226612",
              price: 160,
              price_formatted: "$160",
              title: "Artemis Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231308259380",
              price: 150,
              price_formatted: "$150",
              title: "Artemis Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "4236dca6523a0ec5efc6d395ae99b179b9ebb6c1",
      name: "Lakshmi - NO PRODUCT",
      products: [],
    },
    {
      id: "56850b4b9db04699ac223aa8bacaff2c05e27629",
      name: "Joan of Arc",
      products: [
        {
          description:
            "<p>Joan of Arc, the formidable. This Goddess is a reminder that women can do anything.</p>",
          ending_price_formatted: "$203",
          id: "7171954507828",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-joan-of-arc-necklace-30964258799668.jpg?v=1720805587",
          link: "https://aweinspired.com/products/joan-of-arc-necklace",
          product_block_id: "56850b4b9db04699ac223aa8bacaff2c05e27629",
          starting_price_formatted: "$175",
          tags: [],
          title: "Joan of Arc Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41350142754868",
              price: 193,
              price_formatted: "$193",
              title: "Joan of Arc Necklace",
            },
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "41350142820404",
              price: 175,
              price_formatted: "$175",
              title: "Joan of Arc Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42051810787380",
              price: 203,
              price_formatted: "$203",
              title: "Joan of Arc Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42051810852916",
              price: 185,
              price_formatted: "$185",
              title: "Joan of Arc Necklace",
            },
          ],
        },
        {
          description:
            "<p>Joan of Arc, the formidable. This Goddess is a reminder that women can do anything.</p>",
          ending_price_formatted: "$90",
          id: "6544676421684",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-joan-of-arc-goddess-signet-ring-31082872537140.webp?v=1720780210",
          link: "https://aweinspired.com/products/joan-of-arc-signet-ring",
          product_block_id: "56850b4b9db04699ac223aa8bacaff2c05e27629",
          starting_price_formatted: "$68",
          tags: [],
          title: "Joan of Arc Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41407305580596",
              price: 90,
              price_formatted: "$90",
              title: "Joan of Arc Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41407305613364",
              price: 68,
              price_formatted: "$68",
              title: "Joan of Arc Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "afeb9ce351eda05a987e6b6fbd836de648aa8331",
      name: "Harriet Tubman",
      products: [
        {
          description:
            "<p>Harriet Tubman, conductor of the Underground Railroad. This Goddess brings your natural bravery and leadership qualities to the forefront.</p>",
          ending_price_formatted: "$184",
          id: "7171322183732",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-harriet-tubman-necklace-31247780675636.webp?v=1720795508",
          link: "https://aweinspired.com/products/harriet-tubman-necklace",
          product_block_id: "afeb9ce351eda05a987e6b6fbd836de648aa8331",
          starting_price_formatted: "$158",
          tags: [],
          title: "Harriet Tubman Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41347222011956",
              price: 174,
              price_formatted: "$174",
              title: "Harriet Tubman Necklace",
            },
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "41347222077492",
              price: 158,
              price_formatted: "$158",
              title: "Harriet Tubman Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42050789572660",
              price: 184,
              price_formatted: "$184",
              title: "Harriet Tubman Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42050789638196",
              price: 168,
              price_formatted: "$168",
              title: "Harriet Tubman Necklace",
            },
          ],
        },
        {
          description:
            "<p>Harriet Tubman, conductor of the Underground Railroad. This Goddess brings your natural bravery and leadership qualities to the forefront.</p>",
          ending_price_formatted: "$109",
          id: "4464252420148",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-harriet-tubman-pendant-31275178131508.webp?v=1720795328",
          link: "https://aweinspired.com/products/harriet-tubman-coin-necklace-14k-yellow-gold-vermeil",
          product_block_id: "afeb9ce351eda05a987e6b6fbd836de648aa8331",
          starting_price_formatted: "$103",
          tags: [],
          title: "Harriet Tubman Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231304785972",
              price: 109,
              price_formatted: "$109",
              title: "Harriet Tubman Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231304884276",
              price: 103,
              price_formatted: "$103",
              title: "Harriet Tubman Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "0e61fc2a6265133ede6605a35061940983ef2c01",
      name: "Cleopatra",
      products: [
        {
          description:
            "<p>Cleopatra, Queen of Egypt. The ultimate power piece for timeless elegance and regality.</p>",
          ending_price_formatted: "$203",
          id: "7171962142772",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-cleopatra-necklace-31247799943220.webp?v=1720711084",
          link: "https://aweinspired.com/products/cleopatra-necklace",
          product_block_id: "0e61fc2a6265133ede6605a35061940983ef2c01",
          starting_price_formatted: "$193",
          tags: [],
          title: "Cleopatra Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41350161629236",
              price: 193,
              price_formatted: "$193",
              title: "Cleopatra Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42051719299124",
              price: 203,
              price_formatted: "$203",
              title: "Cleopatra Necklace",
            },
          ],
        },
        {
          description:
            "<p>Cleopatra, Queen of Egypt. The ultimate power piece for timeless elegance and regality.</p>",
          id: "4464033103924",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-cleopatra-pendant-31248587063348.webp?v=1720710908",
          link: "https://aweinspired.com/products/cleopatra-coin-necklace-14k-yellow-gold-vermeil",
          price: 128,
          price_formatted: "$128",
          product_block_id: "0e61fc2a6265133ede6605a35061940983ef2c01",
          tags: [],
          title: "Cleopatra Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231299379252",
              price: 128,
              price_formatted: "$128",
              title: "Cleopatra Pendant",
            },
          ],
        },
        {
          description:
            "<p>Cleopatra, Queen of Egypt. The ultimate power piece for timeless elegance and regality.</p>",
          id: "6544675930164",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-5-cleopatra-signet-ring-30831583494196.jpg?v=1720709116",
          link: "https://aweinspired.com/products/cleopatra-signet-ring",
          price: 53,
          price_formatted: "$53",
          product_block_id: "0e61fc2a6265133ede6605a35061940983ef2c01",
          tags: [],
          title: "Cleopatra Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231313043508",
              price: 53,
              price_formatted: "$53",
              title: "Cleopatra Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231313174580",
              price: 53,
              price_formatted: "$53",
              title: "Cleopatra Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231313305652",
              price: 53,
              price_formatted: "$53",
              title: "Cleopatra Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231313436724",
              price: 53,
              price_formatted: "$53",
              title: "Cleopatra Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231313567796",
              price: 53,
              price_formatted: "$53",
              title: "Cleopatra Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41407356207156",
              price: 53,
              price_formatted: "$53",
              title: "Cleopatra Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "b89ba32ec8c6111f9027c94be7bd28360ac74ad0",
      name: "Mulan",
      products: [
        {
          description:
            "<p>Mulan, the brave. This Goddess of courageous Chinese warrior Mulan will inspire your own fearlessness to come forth.</p>",
          ending_price_formatted: "$190",
          id: "7171973840948",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-mulan-necklace-31247738765364.webp?v=1720869490",
          link: "https://aweinspired.com/products/mulan-necklace",
          product_block_id: "b89ba32ec8c6111f9027c94be7bd28360ac74ad0",
          starting_price_formatted: "$180",
          tags: [],
          title: "Mulan Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41350183223348",
              price: 180,
              price_formatted: "$180",
              title: "Mulan Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42050782986292",
              price: 190,
              price_formatted: "$190",
              title: "Mulan Necklace",
            },
          ],
        },
        {
          description:
            "<p>Mulan, the brave. This Goddess of courageous Chinese warrior Mulan will inspire your own fearlessness to come forth.</p>",
          id: "4464273981492",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-mulan-pendant-31248561045556.webp?v=1720869310",
          link: "https://aweinspired.com/products/mulan-necklace-14k-yellow-gold-vermeil",
          price: 115,
          price_formatted: "$115",
          product_block_id: "b89ba32ec8c6111f9027c94be7bd28360ac74ad0",
          tags: [],
          title: "Mulan Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231304261684",
              price: 115,
              price_formatted: "$115",
              title: "Mulan Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "b4aa9c90f1e6724302fd2d7178c202bedb0601a7",
      name: "Frida Kahlo",
      products: [
        {
          description:
            "<p>Frida, the fearless. Renowned Mexican painter Frida Kahlo will enhance your creative powers.</p>",
          ending_price_formatted: "$185",
          id: "7171979542580",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-frida-kahlo-necklace-30964314538036.jpg?v=1720782925",
          link: "https://aweinspired.com/products/frida-kahlo-necklace",
          product_block_id: "b4aa9c90f1e6724302fd2d7178c202bedb0601a7",
          starting_price_formatted: "$175",
          tags: [],
          title: "Frida Kahlo Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 205,
              compare_at_price_formatted: null,
              id: "41350192529460",
              price: 175,
              price_formatted: "$175",
              title: "Frida Kahlo Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42051744235572",
              price: 185,
              price_formatted: "$185",
              title: "Frida Kahlo Necklace",
            },
          ],
        },
        {
          description:
            "<p>Frida, the fearless. Renowned Mexican painter Frida Kahlo will enhance your creative powers.</p>",
          id: "4464305733684",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-sterling-silver-standard-frida-kahlo-pendant-30831565537332.jpg?v=1720782200",
          link: "https://aweinspired.com/products/frida-kahlo-necklace-gold-vermeil",
          price: 120,
          price_formatted: "$120",
          product_block_id: "b4aa9c90f1e6724302fd2d7178c202bedb0601a7",
          tags: [],
          title: "Frida Kahlo Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231299346484",
              price: 120,
              price_formatted: "$120",
              title: "Frida Kahlo Pendant",
            },
          ],
        },
        {
          description:
            "<p>Frida, the fearless. Renowned Mexican painter Frida Kahlo will enhance your creative powers.</p>",
          ending_price_formatted: "$100",
          id: "7107134652468",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-rings-14k-yellow-gold-vermeil-4-frida-kahlo-signet-ring-31082818240564.webp?v=1720779143",
          link: "https://aweinspired.com/products/frida-kahlo-signet-ring",
          product_block_id: "b4aa9c90f1e6724302fd2d7178c202bedb0601a7",
          starting_price_formatted: "$76",
          tags: [],
          title: "Frida Kahlo Signet Ring",
          type: "Rings",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371206708",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371239476",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371272244",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371305012",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371337780",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371370548",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371403316",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371436084",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371534388",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371567156",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371599924",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371665460",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "41231371698228",
              price: 100,
              price_formatted: "$100",
              title: "Frida Kahlo Signet Ring",
            },
            {
              compare_at_price: 95,
              compare_at_price_formatted: null,
              id: "41231371730996",
              price: 76,
              price_formatted: "$76",
              title: "Frida Kahlo Signet Ring",
            },
          ],
        },
      ],
    },
    {
      id: "5f63df51dc93c256602e4515d243ebfd0ebe1e68",
      name: "RBG",
      products: [
        {
          description:
            "<p>Ruth Bader Ginsburg, the fighter. This Goddess is for every tireless seeker of justice.</p>",
          ending_price_formatted: "$170",
          id: "7171977904180",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-ruth-bader-ginsburg-necklace-31001105530932.webp?v=1720695440",
          link: "https://aweinspired.com/products/ruth-bader-ginsburg-necklace",
          product_block_id: "5f63df51dc93c256602e4515d243ebfd0ebe1e68",
          starting_price_formatted: "$150",
          tags: [],
          title: "Ruth Bader Ginsburg Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41350189318196",
              price: 160,
              price_formatted: "$160",
              title: "Ruth Bader Ginsburg Necklace",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41350189383732",
              price: 150,
              price_formatted: "$150",
              title: "Ruth Bader Ginsburg Necklace",
            },
            {
              compare_at_price: 170,
              compare_at_price_formatted: null,
              id: "42052111532084",
              price: 170,
              price_formatted: "$170",
              title: "Ruth Bader Ginsburg Necklace",
            },
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "42052111597620",
              price: 160,
              price_formatted: "$160",
              title: "Ruth Bader Ginsburg Necklace",
            },
          ],
        },
        {
          description:
            "<p>Ruth Bader Ginsburg, the fighter. This Goddess is for every tireless seeker of justice.</p>",
          ending_price_formatted: "$215",
          id: "4464278503476",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-ruth-bader-ginsburg-pendant-31001104089140.webp?v=1720695608",
          link: "https://aweinspired.com/products/ruth-bader-ginsburg-necklace-gold-vermeil",
          product_block_id: "5f63df51dc93c256602e4515d243ebfd0ebe1e68",
          starting_price_formatted: "$200",
          tags: [],
          title: "Ruth Bader Ginsburg Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41231304097844",
              price: 215,
              price_formatted: "$215",
              title: "Ruth Bader Ginsburg Pendant",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41231304130612",
              price: 200,
              price_formatted: "$200",
              title: "Ruth Bader Ginsburg Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "53c18ba23874461432d559b832728e5c76c37ef4",
      name: "Florence Nightingale",
      products: [
        {
          description:
            "<p>Florence, the healer. Pioneering nurse Florence Nightingale is a symbol of healing and thriving.</p>",
          ending_price_formatted: "$185",
          id: "7171980197940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-florence-nightingale-necklace-31247686565940.webp?v=1720776446",
          link: "https://aweinspired.com/products/florence-nightingale-necklace",
          product_block_id: "53c18ba23874461432d559b832728e5c76c37ef4",
          starting_price_formatted: "$175",
          tags: [],
          title: "Florence Nightingale Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41350194757684",
              price: 175,
              price_formatted: "$175",
              title: "Florence Nightingale Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42052153147444",
              price: 185,
              price_formatted: "$185",
              title: "Florence Nightingale Necklace",
            },
          ],
        },
        {
          description:
            "<p>Florence, the healer. Pioneering nurse Florence Nightingale is a symbol of healing and thriving.</p>",
          id: "4524953862196",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-florence-nightingale-pendant-31248571531316.webp?v=1720773560",
          link: "https://aweinspired.com/products/florence-nightingale-coin-necklace-14k-yellow-gold-vermeil",
          price: 120,
          price_formatted: "$120",
          product_block_id: "53c18ba23874461432d559b832728e5c76c37ef4",
          tags: [],
          title: "Florence Nightingale Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231303540788",
              price: 120,
              price_formatted: "$120",
              title: "Florence Nightingale Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "db85ac7514c2a1e0dbe04cf56429034a33e7c939",
      name: "Mother Mary",
      products: [
        {
          description:
            "<p>Mother Mary, devout goddess. This Goddess is representative of a woman’s courage and strength of character.</p>",
          ending_price_formatted: "$228",
          id: "7243583356980",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-standard-mother-mary-necklace-31332860657716.webp?v=1720871464",
          link: "https://aweinspired.com/products/mother-mary-necklace",
          product_block_id: "db85ac7514c2a1e0dbe04cf56429034a33e7c939",
          starting_price_formatted: "$204",
          tags: [],
          title: "Mother Mary Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42218967564340",
              price: 218,
              price_formatted: "$218",
              title: "Mother Mary Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "42218967597108",
              price: 204,
              price_formatted: "$204",
              title: "Mother Mary Necklace",
            },
            {
              compare_at_price: 245,
              compare_at_price_formatted: null,
              id: "42218967662644",
              price: 228,
              price_formatted: "$228",
              title: "Mother Mary Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42218967695412",
              price: 214,
              price_formatted: "$214",
              title: "Mother Mary Necklace",
            },
          ],
        },
        {
          description:
            "<p>Mother Mary, devout goddess. This Goddess is representative of a woman’s courage and strength of character.</p>",
          ending_price_formatted: "$153",
          id: "4856213602356",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-mother-mary-tablet-30831581462580.jpg?v=1720870750",
          link: "https://aweinspired.com/products/mother-mary-tablet-necklace",
          product_block_id: "db85ac7514c2a1e0dbe04cf56429034a33e7c939",
          starting_price_formatted: "$149",
          tags: [],
          title: "Mother Mary Tablet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 170,
              compare_at_price_formatted: null,
              id: "41231312486452",
              price: 153,
              price_formatted: "$153",
              title: "Mother Mary Tablet",
            },
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231312519220",
              price: 149,
              price_formatted: "$149",
              title: "Mother Mary Tablet",
            },
          ],
        },
      ],
    },
    {
      id: "77f67a15be1f201e111b7cde5a2ad9feadaf6e77",
      name: "Marsha P Johnson",
      products: [
        {
          description:
            "<p>Marsha P Johnson Goddess pendant honors the trailblazing LBGTQ+ activist.</p>",
          ending_price_formatted: "$196",
          id: "7173351440436",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-marsha-p-johnson-necklace-30984556445748.jpg?v=1720823593",
          link: "https://aweinspired.com/products/marsha-p-johnson-necklace",
          product_block_id: "77f67a15be1f201e111b7cde5a2ad9feadaf6e77",
          starting_price_formatted: "$172",
          tags: [],
          title: "Marsha P Johnson Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41357097205812",
              price: 188,
              price_formatted: "$188",
              title: "Marsha P Johnson Necklace",
            },
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41357097238580",
              price: 172,
              price_formatted: "$172",
              title: "Marsha P Johnson Necklace",
            },
            {
              compare_at_price: 245,
              compare_at_price_formatted: null,
              id: "42051804364852",
              price: 196,
              price_formatted: "$196",
              title: "Marsha P Johnson Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42051804397620",
              price: 180,
              price_formatted: "$180",
              title: "Marsha P Johnson Necklace",
            },
          ],
        },
        {
          description:
            "<p>Marsha P Johnson Goddess pendant honors the trailblazing LBGTQ+ activist.</p>",
          ending_price_formatted: "$128",
          id: "6550059319348",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-marsha-p-johnson-pendant-30831581167668.png?v=1720823590",
          link: "https://aweinspired.com/products/marsha-p-johnson-necklace-14k-yellow-gold-vermeil",
          product_block_id: "77f67a15be1f201e111b7cde5a2ad9feadaf6e77",
          starting_price_formatted: "$120",
          tags: [],
          title: "Marsha P Johnson Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231312158772",
              price: 128,
              price_formatted: "$128",
              title: "Marsha P Johnson Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231312191540",
              price: 120,
              price_formatted: "$120",
              title: "Marsha P Johnson Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "cba93a01faee8b8e113b63f9ec7a48fa5eecbeb2",
      name: "Marie Curie",
      products: [
        {
          description:
            "<p>Marie, the genius. This Goddess of Nobel prize winning chemist and physicist Marie Curie celebrates intelligence and hard work.</p>",
          ending_price_formatted: "$203",
          id: "7171979968564",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-marie-curie-necklace-30964341440564.jpg?v=1720818554",
          link: "https://aweinspired.com/products/marie-curie-necklace",
          product_block_id: "cba93a01faee8b8e113b63f9ec7a48fa5eecbeb2",
          starting_price_formatted: "$193",
          tags: [],
          title: "Marie Curie Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41350194364468",
              price: 193,
              price_formatted: "$193",
              title: "Marie Curie Necklace",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "42050782429236",
              price: 203,
              price_formatted: "$203",
              title: "Marie Curie Necklace",
            },
          ],
        },
        {
          description:
            "<p>Marie, the genius. This Goddess of Nobel prize winning chemist and physicist Marie Curie celebrates intelligence and hard work.</p>",
          ending_price_formatted: "$128",
          id: "4479546392628",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-marie-curie-pendant-30831573401652.jpg?v=1720826651",
          link: "https://aweinspired.com/products/marie-curie-necklace-gold-vermeil",
          product_block_id: "cba93a01faee8b8e113b63f9ec7a48fa5eecbeb2",
          starting_price_formatted: "$120",
          tags: [],
          title: "Marie Curie Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231306194996",
              price: 128,
              price_formatted: "$128",
              title: "Marie Curie Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41407126929460",
              price: 120,
              price_formatted: "$120",
              title: "Marie Curie Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "630182eab780af6100ce992c55997f118ce829bb",
      name: "Sappho",
      products: [
        {
          description:
            '<p><meta charset="utf-8">The greatest lyrical poet from antiquity, the romantic Sappho – hailing from the Greek island of Lesbos – is a timeless queer icon.</p>',
          ending_price_formatted: "$225",
          id: "7175140311092",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-sappho-necklace-31247679553588.webp?v=1720851841",
          link: "https://aweinspired.com/products/sappho-necklace",
          product_block_id: "630182eab780af6100ce992c55997f118ce829bb",
          starting_price_formatted: "$200",
          tags: [],
          title: "Sappho Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 215,
              compare_at_price_formatted: null,
              id: "41366567256116",
              price: 215,
              price_formatted: "$215",
              title: "Sappho Necklace",
            },
            {
              compare_at_price: 200,
              compare_at_price_formatted: null,
              id: "41366567288884",
              price: 200,
              price_formatted: "$200",
              title: "Sappho Necklace",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "42044328869940",
              price: 225,
              price_formatted: "$225",
              title: "Sappho Necklace",
            },
            {
              compare_at_price: 210,
              compare_at_price_formatted: null,
              id: "42044328902708",
              price: 210,
              price_formatted: "$210",
              title: "Sappho Necklace",
            },
          ],
        },
        {
          description:
            '<p><meta charset="utf-8">The greatest lyrical poet from antiquity, the romantic Sappho – hailing from the Greek island of Lesbos – is a timeless queer icon.</p>',
          ending_price_formatted: "$160",
          id: "7096507334708",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-sappho-pendant-30981983666228.jpg?v=1720876689",
          link: "https://aweinspired.com/products/sappho-pendant",
          product_block_id: "630182eab780af6100ce992c55997f118ce829bb",
          starting_price_formatted: "$150",
          tags: [],
          title: "Sappho Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41231369011252",
              price: 160,
              price_formatted: "$160",
              title: "Sappho Pendant",
            },
            {
              compare_at_price: 150,
              compare_at_price_formatted: null,
              id: "41231369109556",
              price: 150,
              price_formatted: "$150",
              title: "Sappho Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "6d5faf1173bcb8e51f24dfd8d2fd9bfb1290c7ce",
      name: "111",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "6d5faf1173bcb8e51f24dfd8d2fd9bfb1290c7ce",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "6d5faf1173bcb8e51f24dfd8d2fd9bfb1290c7ce",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "401d354d4357f729801b87d40fe9d1aed9d57789",
      name: "222",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "401d354d4357f729801b87d40fe9d1aed9d57789",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "401d354d4357f729801b87d40fe9d1aed9d57789",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "964bcb181aeb655888b9812a2c4f2bcc16dddb63",
      name: "333",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "964bcb181aeb655888b9812a2c4f2bcc16dddb63",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "964bcb181aeb655888b9812a2c4f2bcc16dddb63",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "dd9f87a8569de270cd20014dc1939407e4b380b9",
      name: "444",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "dd9f87a8569de270cd20014dc1939407e4b380b9",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "dd9f87a8569de270cd20014dc1939407e4b380b9",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "7f3dfff926f47b7554cac4298c5de74015ed2b91",
      name: "555",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "7f3dfff926f47b7554cac4298c5de74015ed2b91",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "7f3dfff926f47b7554cac4298c5de74015ed2b91",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "c18678de3ae46a289123719349eaa9e4a3e555a7",
      name: "666",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "c18678de3ae46a289123719349eaa9e4a3e555a7",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "c18678de3ae46a289123719349eaa9e4a3e555a7",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "64d9faaa6c2fa3d2bc88f6a144847cf68ba66606",
      name: "777",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "64d9faaa6c2fa3d2bc88f6a144847cf68ba66606",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "64d9faaa6c2fa3d2bc88f6a144847cf68ba66606",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "92ddf5fb6e269d442cec5e0ad802ad6f9668b5e2",
      name: "888",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "92ddf5fb6e269d442cec5e0ad802ad6f9668b5e2",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "92ddf5fb6e269d442cec5e0ad802ad6f9668b5e2",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "65faa022b1c79b57bbba96e8653d3b815b4c70d2",
      name: "999",
      products: [
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$136",
          id: "7212990758964",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-111-16-18-angel-number-necklace-31166623219764.webp?v=1720702261",
          link: "https://aweinspired.com/products/angel-number-necklace",
          product_block_id: "65faa022b1c79b57bbba96e8653d3b815b4c70d2",
          starting_price_formatted: "$109",
          tags: [],
          title: "Angel Number Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323911732",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323944500",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856323977268",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324010036",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324042804",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324075572",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324108340",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324141108",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41856324173876",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324206644",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324239412",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324272180",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324304948",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324337716",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324370484",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324403252",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324436020",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 109,
              compare_at_price_formatted: null,
              id: "41856324468788",
              price: 109,
              price_formatted: "$109",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538878004",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538910772",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538943540",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968538976308",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539009076",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539041844",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539074612",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539107380",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 136,
              compare_at_price_formatted: null,
              id: "41968539140148",
              price: 136,
              price_formatted: "$136",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539172916",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539205684",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539238452",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539271220",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539303988",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539336756",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539369524",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539402292",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
            {
              compare_at_price: 118,
              compare_at_price_formatted: null,
              id: "41968539435060",
              price: 118,
              price_formatted: "$118",
              title: "Angel Number Necklace",
            },
          ],
        },
        {
          description:
            "<p>When you see these numbers in your everyday life, they can be perceived as a powerfully significant message from your spirit guides. Let your intuition lead you to identify the numbers that resonate with you — you’ll know if they’ve been following you around, or if a certain number’s significance aligns with your heart and mind at this stage in your journey.</p>\n<p>111: New beginnings. Wishes granted. Intuition. The powerful appearance of 111 suggests that new opportunities are on the horizon. It encourages you to trust your instincts and remain positive, as your thoughts and desires are aligning with the universe. This is the time to make a wish, set something in motion, and know that the universe is saying yes.</p>\n<p>222: Balance. Hope. Mystical alignment. Sweet, centered and dreamy 222 is a sign of balance and harmony. It brings a message of hope and encouragement — you are on the right path. In this moment, you can and should reach out to your trusted companion to rely on, as your desires are aligned in a higher realm and will be most prosperous together.</p>\n<p>333: Optimism. Good Fortune. Creativity. When 333 appears, it signifies a time of creativity and positive energy — your optimistic outlook will attract abundance and joy. Give your mind, body and spirit over to the creative muse and allow yourself to accept the gifts the universe bestows.</p>\n<p>444: Stability. Empowerment. Responsibility. Powerful 444 is a sign of stability and empowerment. It encourages you to take responsibility for your actions and decisions. This sequence reveals how angels are supporting you in building a solid foundation that will empower you to move forward grounded, supported and fully capable.</p>\n<p>555: Personal growth. Change. Transformation. Especially when you are feeling stagnant or lost, 555 indicates a period of significant, magical personal growth and change. Embrace the transformations happening in your life, as they are aligned with your spiritual wellbeing and, through this process, you will embrace your highest self.</p>\n<p>666: Introspection. Solitude. Compassion. Often misunderstood, 666 urges you to take time for introspection and self-discovery. It doesn't necessarily carry negative connotations; instead, it encourages you to seek balance, intentionally practice sacred solitude, and express compassion towards yourself and others.</p>\n<p>777: Luck. Mysticism. Psychic manifestation. Radiant 777 is a highly spiritual number associated with luck and divine guidance. It suggests that your efforts are in alignment with the universe and that your manifestation abilities are heightened, so this is the time to allow your natural effervescence and psychic awareness to draw in and take hold of opportunities.</p>\n<p>888: Infinite abundance. Manifestation. Universal connection. Divine 888 is a powerful symbol of abundance and manifestation. It indicates that your financial and material efforts are harmonizing, as a period of prosperity approaches. From the stars above to the fruits of the earth, all things are making themselves available to you.</p>\n<p>999: Release. Renewal. Freedom. 999 marks the completion of a cycle and encourages you to embrace change. It signifies the need to release old habits or situations to make room for renewal and new opportunities in your life. Take great courage as the universe offers you this gentle nudge in the direction of freedom and exploration.</p>",
          ending_price_formatted: "$75",
          id: "7212985253940",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-111-mini-angel-number-amulet-31163278950452.webp?v=1720734313",
          link: "https://aweinspired.com/products/angel-number-amulet",
          product_block_id: "65faa022b1c79b57bbba96e8653d3b815b4c70d2",
          starting_price_formatted: "$65",
          tags: [],
          title: "Angel Number Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311033908",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311066676",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311099444",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311132212",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311164980",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311197748",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311230516",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311263284",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 75,
              compare_at_price_formatted: null,
              id: "41856311296052",
              price: 75,
              price_formatted: "$75",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311328820",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311361588",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311394356",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311427124",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311459892",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311492660",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311525428",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311558196",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41856311590964",
              price: 65,
              price_formatted: "$65",
              title: "Angel Number Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "f53887cbec5ed155f0b536f7ef58b1ce32919fcc",
      name: "Gate of Hades",
      products: [],
    },
    {
      id: "c9e7cc38940c3b48b27dce608e97b268f62bdd23",
      name: "Woman Power",
      products: [],
    },
    {
      id: "4c80cf35ac0dc8bdb0226d5a42dc517cd043ec76",
      name: "Spiked Heart",
      products: [
        {
          description:
            "It may be wrong, but it feels so right. The spiked heart is like a thorned rose — guarded, but heartrendingly beautiful and impossible to resist. Shaped like a padlock, this pendant represents the act of opening your heart to the right person at the right time. It may not be forever, but you’d do it again in a heartbeat.",
          ending_price_formatted: "$80",
          id: "7228911747124",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-spiked-heart-pendant-31231963234356.webp?v=1720685887",
          link: "https://aweinspired.com/products/spiked-heart-pendant",
          product_block_id: "4c80cf35ac0dc8bdb0226d5a42dc517cd043ec76",
          starting_price_formatted: "$70",
          tags: [],
          title: "Spiked Heart Pendant",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 80,
              compare_at_price_formatted: null,
              id: "42030863646772",
              price: 80,
              price_formatted: "$80",
              title: "Spiked Heart Pendant",
            },
            {
              compare_at_price: 70,
              compare_at_price_formatted: null,
              id: "42030863679540",
              price: 70,
              price_formatted: "$70",
              title: "Spiked Heart Pendant",
            },
          ],
        },
      ],
    },
    {
      id: "fd98bce9793ce8e699a3f08b11d6357d6cf54e9d",
      name: "Opal Sun",
      products: [
        {
          description:
            "<p>At last, the perfect sun pendant with a glorious white opal and shimmering cosmic rays. A must-have for the Awe collector.</p>",
          ending_price_formatted: "$130",
          id: "7125058879540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-opal-sun-amulet-30834618990644.webp?v=1720884785",
          link: "https://aweinspired.com/products/opal-sun-necklace",
          product_block_id: "fd98bce9793ce8e699a3f08b11d6357d6cf54e9d",
          starting_price_formatted: "$120",
          tags: [],
          title: "Opal Sun Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41232622092340",
              price: 130,
              price_formatted: "$130",
              title: "Opal Sun Amulet",
            },
            {
              compare_at_price: 120,
              compare_at_price_formatted: null,
              id: "41232622125108",
              price: 120,
              price_formatted: "$120",
              title: "Opal Sun Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "dc98eee769e21ea9e3f7681c96a3b2973f11eb76",
      name: "Diamond Moon Wave",
      products: [
        {
          description:
            "<p>The moon is a major influence on the Earth's tides, which represent the ups and downs of life while the moon represents the rhythm of time. Throughout our lives, we experience ups and downs that shape our characters into becoming our true selves.</p>",
          ending_price_formatted: "$120",
          id: "6553183748148",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-diamond-moon-wave-amulet-31001081413684.webp?v=1720788319",
          link: "https://aweinspired.com/products/moon-wave-charm-amulet",
          product_block_id: "dc98eee769e21ea9e3f7681c96a3b2973f11eb76",
          starting_price_formatted: "$110",
          tags: [],
          title: "Diamond Moon Wave Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 120,
              compare_at_price_formatted: null,
              id: "41231424749620",
              price: 120,
              price_formatted: "$120",
              title: "Diamond Moon Wave Amulet",
            },
            {
              compare_at_price: 110,
              compare_at_price_formatted: null,
              id: "41231424782388",
              price: 110,
              price_formatted: "$110",
              title: "Diamond Moon Wave Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "ae986b4fc3cceaebf680a9f8c2bd5c02067dde8f",
      name: "Triple Moon",
      products: [
        {
          description:
            "<p>The waxing, full and waning moons of the Triple Moon represent divine feminine power in all of its aspects - intuition, creativity, wisdom &amp; mystery. It also symbolizes the three life stages of a woman: <br>        -  Waxing Crescent Moon (the Maiden): Purity, youth, beginnings, excitement, enchantment, expansion  <br>        - Full Moon (the Mother): Fulfillment, potency, compassion, giving, nurturing, protection, power  <br>        - Waning Moon (the Crone): Maturity, wisdom, experience, understanding, completion, rebirth</p>",
          ending_price_formatted: "$115",
          id: "6555388248116",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-mini-triple-moon-amulet-31001110577204.webp?v=1720644493",
          link: "https://aweinspired.com/products/triple-moon-charm-necklace",
          product_block_id: "ae986b4fc3cceaebf680a9f8c2bd5c02067dde8f",
          starting_price_formatted: "$105",
          tags: [],
          title: "Triple Moon Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41231320088628",
              price: 115,
              price_formatted: "$115",
              title: "Triple Moon Amulet",
            },
            {
              compare_at_price: 105,
              compare_at_price_formatted: null,
              id: "41231320121396",
              price: 105,
              price_formatted: "$105",
              title: "Triple Moon Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "de96671aab57aa95771aa4da7dd6ac5a0afdcb99",
      name: "Diamond Sword",
      products: [
        {
          description:
            "<p>The sword is an ancient symbol of power, protection and authority. On a metaphysical level, the sword represents the penetrating power of the intellect, spiritual decision and the purity of what is sacred.</p>",
          ending_price_formatted: "$120",
          id: "6560362496052",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-diamond-sword-amulet-30831586508852.jpg?v=1720755378",
          link: "https://aweinspired.com/products/sword-charm-amulet",
          product_block_id: "de96671aab57aa95771aa4da7dd6ac5a0afdcb99",
          starting_price_formatted: "$110",
          tags: [],
          title: "Diamond Sword Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 120,
              compare_at_price_formatted: null,
              id: "41231318581300",
              price: 120,
              price_formatted: "$120",
              title: "Diamond Sword Amulet",
            },
            {
              compare_at_price: 110,
              compare_at_price_formatted: null,
              id: "41231318614068",
              price: 110,
              price_formatted: "$110",
              title: "Diamond Sword Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "8e78d7a72411a0c20de48dd2f4f8ab869375a882",
      name: "Crescent Snake Eye",
      products: [
        {
          description:
            "<p>With the The Crescent Snake Eye Amulet Necklace adorning your neckline, you carry the essence of both celestial wisdom and earthly magic. Allow its energy to inspire you and awaken the dormant powers within.</p>",
          ending_price_formatted: "$195",
          id: "7096272257076",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-crescent-snake-eye-amulet-30831643263028.jpg?v=1720710001",
          link: "https://aweinspired.com/products/crescent-snake-amulet",
          product_block_id: "8e78d7a72411a0c20de48dd2f4f8ab869375a882",
          starting_price_formatted: "$185",
          tags: [],
          title: "Crescent Snake Eye Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 195,
              compare_at_price_formatted: null,
              id: "41231370682420",
              price: 195,
              price_formatted: "$195",
              title: "Crescent Snake Eye Amulet",
            },
            {
              compare_at_price: 185,
              compare_at_price_formatted: null,
              id: "41231370715188",
              price: 185,
              price_formatted: "$185",
              title: "Crescent Snake Eye Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "1329d8a30161c9bfe08c5d34f051300a9e912d24",
      name: "Magic Mushroom",
      products: [
        {
          description:
            "<p>There’s magic everywhere you look. This Magic Mushroom was plucked from a fairy circle, featuring whimsical splashes of bezel-set London blue topaz, purple amethyst and green amethyst on white mother of pearl with a textured stem.</p>\n<p>Mushrooms are the fruiting bodies of a great underground ‘mycorrhizal network,’ a communication structure that connects trees as well as fungi. Each mushroom is a symbol of this mysterious, silent language of the forest.</p>",
          ending_price_formatted: "$145",
          id: "7396342169652",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-large-14k-yellow-gold-vermeil-magic-mushroom-amulet-31873211007028.webp?v=1720821792",
          link: "https://aweinspired.com/products/magic-mushroom-amulet",
          product_block_id: "1329d8a30161c9bfe08c5d34f051300a9e912d24",
          starting_price_formatted: "$135",
          tags: [],
          title: "Magic Mushroom Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "43290110394420",
              price: 145,
              price_formatted: "$145",
              title: "Magic Mushroom Amulet",
            },
            {
              compare_at_price: 135,
              compare_at_price_formatted: null,
              id: "43290110427188",
              price: 135,
              price_formatted: "$135",
              title: "Magic Mushroom Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "ab0ee43c50f9949e7c92e327f22c1e18a3c80ddc",
      name: "Pomegranate",
      products: [
        {
          description:
            "<p>It was a single seed from the pomegranate that bound Persephone to the underworld. Never underestimate the power of this antixioxidant-rich fruit. Go ahead, taste the forbidden.</p>",
          ending_price_formatted: "$115",
          id: "6557174399028",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-mini-pomegranate-amulet-30831586312244.jpg?v=1720845550",
          link: "https://aweinspired.com/products/pomegranate-charm-necklace",
          product_block_id: "ab0ee43c50f9949e7c92e327f22c1e18a3c80ddc",
          starting_price_formatted: "$105",
          tags: [],
          title: "Pomegranate Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41231318351924",
              price: 115,
              price_formatted: "$115",
              title: "Pomegranate Amulet",
            },
            {
              compare_at_price: 105,
              compare_at_price_formatted: null,
              id: "41231318384692",
              price: 105,
              price_formatted: "$105",
              title: "Pomegranate Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "02e88250403999406ccf22978645d03afde9759a",
      name: "Magical Cat",
      products: [
        {
          description:
            "<p>Cats have held a variety of meanings for different cultures throughout history. For ancient Egyptians, cats came to be revered as symbols of protection and magic. Wear the Enduring Magic of the Cat Amulet Necklace every day to welcome this protective and magical energy into your life.</p>",
          id: "6952087683124",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-magical-cat-amulet-30831679340596.jpg?v=1720821436",
          link: "https://aweinspired.com/products/enduring-magic-cat-amulet",
          price: 65,
          price_formatted: "$65",
          product_block_id: "02e88250403999406ccf22978645d03afde9759a",
          tags: [],
          title: "Magical Cat Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 65,
              compare_at_price_formatted: null,
              id: "41231406759988",
              price: 65,
              price_formatted: "$65",
              title: "Magical Cat Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "975a74f57ec9e9be12bb452a1eb83db37c4ddf18",
      name: "Lucky Dragonfly",
      products: [
        {
          description:
            "<p>With wings of green amethyst, purple amethyst, citrine, London blue topaz and white topaz, reminiscent of stained glass, the Lucky Dragonfly brings happy-go-lucky magic and whimsy to your wanderings.</p>\n<p>This colorful piece is a reminder to live in awe of the immeasurable beauty and value in the smallest wonders of the natural world.</p>",
          id: "7396290265140",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-standard-lucky-dragonfly-amulet-31873031831604.webp?v=1720813150",
          link: "https://aweinspired.com/products/lucky-dragonfly-amulet",
          price: 125,
          price_formatted: "$125",
          product_block_id: "975a74f57ec9e9be12bb452a1eb83db37c4ddf18",
          tags: [],
          title: "Lucky Dragonfly Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 125,
              compare_at_price_formatted: null,
              id: "44184735219764",
              price: 125,
              price_formatted: "$125",
              title: "Lucky Dragonfly Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "c01a03832d4a9d15e4d98437f85a02bcc9437a85",
      name: "Red - NO PRODUCT",
      products: [],
    },
    {
      id: "ae69d736482f74f977f42db08a4328260f7b8655",
      name: "Orange - NO PRODUCT",
      products: [],
    },
    {
      id: "6717af620e63495e9bc8a96ca341938c7bb890ae",
      name: "Yellow - NO PRODUCT",
      products: [],
    },
    {
      id: "ff5e0b66467ac107b34f422a913173e12489cca7",
      name: "Green - NO PRODUCT",
      products: [],
    },
    {
      id: "34426562048c44a4b75814e28ddedcfc073bbfc2",
      name: "Blue - NO PRODUCT",
      products: [],
    },
    {
      id: "9e0b6407e74ad3db14608e10396e8861c127da44",
      name: "Indigo - NO PRODUCT",
      products: [],
    },
    {
      id: "b937e1db93d95bdd8447b298107d3a1d7cc9f440",
      name: "Violet - NO PRODUCT",
      products: [],
    },
    {
      id: "9a198d2c6ad9577e75fe653841b01b7de93e97a5",
      name: "Aries - Element",
      products: [
        {
          description:
            "The Fire signs are Aries, Leo and Sagittarius. If these signs are anywhere in your chart, you claim Fire sign energy. Passionate and intense, your energy is high, dynamic and magnetizing. You value your freedom, command attention, and live life on your own terms above all. You have the powerful ability to regenerate no matter what may happen. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Carnelian, an energetic stone of passion, courage and strength. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211523833908",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-fire-16-18-box-chain-element-necklace-31730652479540.gif?v=1720758647",
          link: "https://aweinspired.com/products/fire-element-necklace",
          product_block_id: "9a198d2c6ad9577e75fe653841b01b7de93e97a5",
          starting_price_formatted: "$252",
          tags: [],
          title: "Fire Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853856219188",
              price: 270,
              price_formatted: "$270",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853856251956",
              price: 279,
              price_formatted: "$279",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853856284724",
              price: 252,
              price_formatted: "$252",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853856317492",
              price: 261,
              price_formatted: "$261",
              title: "Fire Element Necklace",
            },
          ],
        },
        {
          description:
            "The Fire signs are Aries, Leo and Sagittarius. If these signs are anywhere in your chart, you claim Fire sign energy. Passionate and intense, your energy is high, dynamic and magnetizing. You value your freedom, command attention, and live life on your own terms above all. You have the powerful ability to regenerate no matter what may happen. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Carnelian, an energetic stone of passion, courage and strength. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211446173748",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-fire-element-amulet-31737062752308.gif?v=1720777696",
          link: "https://aweinspired.com/products/fire-element-amulet",
          product_block_id: "9a198d2c6ad9577e75fe653841b01b7de93e97a5",
          starting_price_formatted: "$225",
          tags: [],
          title: "Fire Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832998010932",
              price: 225,
              price_formatted: "$225",
              title: "Fire Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832998043700",
              price: 235,
              price_formatted: "$235",
              title: "Fire Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "1c1b7cc75752574fa00e448b4518139730716f60",
      name: "Taurus - Element",
      products: [
        {
          description:
            "The Earth signs are Capricorn, Taurus and Virgo. If these signs are anywhere in your chart, you claim Earth sign energy. Grounded and loyal, you thrive in stable environments. You value practicality and balance, are extremely hardworking and understand the value of time, tradition and quality. You have the essential ability to create a warm, safe and comforting place wherever you are. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Malachite, a deeply spiritual stone of transformation that helps cultivate a life filled with love, growth, and purpose. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211520262196",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-earth-element-necklace-31730652348468.gif?v=1720757001",
          link: "https://aweinspired.com/products/earth-element-necklace",
          product_block_id: "1c1b7cc75752574fa00e448b4518139730716f60",
          starting_price_formatted: "$252",
          tags: [],
          title: "Earth Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853813096500",
              price: 270,
              price_formatted: "$270",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853813129268",
              price: 252,
              price_formatted: "$252",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853825679412",
              price: 279,
              price_formatted: "$279",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853825712180",
              price: 261,
              price_formatted: "$261",
              title: "Earth Element Necklace",
            },
          ],
        },
        {
          description:
            "The Earth signs are Capricorn, Taurus and Virgo. If these signs are anywhere in your chart, you claim Earth sign energy. Grounded and loyal, you thrive in stable environments. You value practicality and balance, are extremely hardworking and understand the value of time, tradition and quality. You have the essential ability to create a warm, safe and comforting place wherever you are. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Malachite, a deeply spiritual stone of transformation that helps cultivate a life filled with love, growth, and purpose. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211445911604",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-earth-element-amulet-31737062326324.gif?v=1720755374",
          link: "https://aweinspired.com/products/earth-element-amulet",
          product_block_id: "1c1b7cc75752574fa00e448b4518139730716f60",
          starting_price_formatted: "$225",
          tags: [],
          title: "Earth Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41842765234228",
              price: 235,
              price_formatted: "$235",
              title: "Earth Element Amulet",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41842847907892",
              price: 225,
              price_formatted: "$225",
              title: "Earth Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "c0fab9e8126715376b2f2359983b75fb563b4736",
      name: "Gemini - Element",
      products: [
        {
          description:
            "The Air signs are Aquarius, Gemini and Libra. If these signs are anywhere in your chart, you claim Air sign energy. Adventurous, cool-headed and sociable, you are a seeker of truth and understand the value of analytical thinking and calm communication. You have the ability to understand ephemeral concepts with ease and flexibility. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with white Mother of Pearl, which is known to have deeply soothing, healing properties that protect the wearer from suffering negative energy. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211520524340",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-air-element-necklace-31730652184628.gif?v=1720639084",
          link: "https://aweinspired.com/products/air-element-necklace",
          product_block_id: "c0fab9e8126715376b2f2359983b75fb563b4736",
          starting_price_formatted: "$252",
          tags: [],
          title: "Air Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853702307892",
              price: 270,
              price_formatted: "$270",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853702340660",
              price: 279,
              price_formatted: "$279",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853702373428",
              price: 252,
              price_formatted: "$252",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853702406196",
              price: 261,
              price_formatted: "$261",
              title: "Air Element Necklace",
            },
          ],
        },
        {
          description:
            "The Air signs are Aquarius, Gemini and Libra. If these signs are anywhere in your chart, you claim Air sign energy. Adventurous, cool-headed and sociable, you are a seeker of truth and understand the value of analytical thinking and calm communication. You have the ability to understand ephemeral concepts with ease and flexibility. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with white Mother of Pearl, which is known to have deeply soothing, healing properties that protect the wearer from suffering negative energy. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211446042676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-air-element-amulet-31737061736500.gif?v=1720638911",
          link: "https://aweinspired.com/products/air-element-amulet",
          product_block_id: "c0fab9e8126715376b2f2359983b75fb563b4736",
          starting_price_formatted: "$225",
          tags: [],
          title: "Air Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832997257268",
              price: 225,
              price_formatted: "$225",
              title: "Air Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832997290036",
              price: 235,
              price_formatted: "$235",
              title: "Air Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "e1528d84e25b134f3113d892904e07cb47387871",
      name: "Cancer - Element",
      products: [
        {
          description:
            "The Water signs are Pisces, Cancer and Scorpio. If these signs are anywhere in your chart, you claim Water sign energy. Compassionate and sentimental, you run deep and have an imaginative, sensitive nature. You understand the power and meaning of your emotional responses. You have the ability of intuition, perceiving signs, symbols and subtle cues that others may miss. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Abalone, which is known to balance emotions, relieve anxiety and help to release negative emotions and replace them with love and self compassion. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211523964980",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-water-16-18-box-chain-element-necklace-31730652577844.gif?v=1720762411",
          link: "https://aweinspired.com/products/water-element-necklace",
          product_block_id: "e1528d84e25b134f3113d892904e07cb47387871",
          starting_price_formatted: "$252",
          tags: [],
          title: "Water Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41832997027892",
              price: 252,
              price_formatted: "$252",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41832997060660",
              price: 270,
              price_formatted: "$270",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853977919540",
              price: 261,
              price_formatted: "$261",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853977952308",
              price: 279,
              price_formatted: "$279",
              title: "Water Element Necklace",
            },
          ],
        },
        {
          description:
            "The Water signs are Pisces, Cancer and Scorpio. If these signs are anywhere in your chart, you claim Water sign energy. Compassionate and sentimental, you run deep and have an imaginative, sensitive nature. You understand the power and meaning of your emotional responses. You have the ability of intuition, perceiving signs, symbols and subtle cues that others may miss. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Abalone, which is known to balance emotions, relieve anxiety and help to release negative emotions and replace them with love and self compassion. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211447550004",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-water-element-amulet-31737063374900.gif?v=1720652228",
          link: "https://aweinspired.com/products/water-element-amulet",
          product_block_id: "e1528d84e25b134f3113d892904e07cb47387871",
          starting_price_formatted: "$225",
          tags: [],
          title: "Water Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832996634676",
              price: 225,
              price_formatted: "$225",
              title: "Water Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832996667444",
              price: 235,
              price_formatted: "$235",
              title: "Water Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "6808a15a634f19f9bf2c56183124a8ee48690a0e",
      name: "Leo - Element",
      products: [
        {
          description:
            "The Fire signs are Aries, Leo and Sagittarius. If these signs are anywhere in your chart, you claim Fire sign energy. Passionate and intense, your energy is high, dynamic and magnetizing. You value your freedom, command attention, and live life on your own terms above all. You have the powerful ability to regenerate no matter what may happen. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Carnelian, an energetic stone of passion, courage and strength. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211523833908",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-fire-16-18-box-chain-element-necklace-31730652479540.gif?v=1720758647",
          link: "https://aweinspired.com/products/fire-element-necklace",
          product_block_id: "6808a15a634f19f9bf2c56183124a8ee48690a0e",
          starting_price_formatted: "$252",
          tags: [],
          title: "Fire Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853856219188",
              price: 270,
              price_formatted: "$270",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853856251956",
              price: 279,
              price_formatted: "$279",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853856284724",
              price: 252,
              price_formatted: "$252",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853856317492",
              price: 261,
              price_formatted: "$261",
              title: "Fire Element Necklace",
            },
          ],
        },
        {
          description:
            "The Fire signs are Aries, Leo and Sagittarius. If these signs are anywhere in your chart, you claim Fire sign energy. Passionate and intense, your energy is high, dynamic and magnetizing. You value your freedom, command attention, and live life on your own terms above all. You have the powerful ability to regenerate no matter what may happen. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Carnelian, an energetic stone of passion, courage and strength. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211446173748",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-fire-element-amulet-31737062752308.gif?v=1720777696",
          link: "https://aweinspired.com/products/fire-element-amulet",
          product_block_id: "6808a15a634f19f9bf2c56183124a8ee48690a0e",
          starting_price_formatted: "$225",
          tags: [],
          title: "Fire Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832998010932",
              price: 225,
              price_formatted: "$225",
              title: "Fire Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832998043700",
              price: 235,
              price_formatted: "$235",
              title: "Fire Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "ecae2d891df20ba4080edbfbd69b7325a7d45e94",
      name: "Virgo - Element",
      products: [
        {
          description:
            "The Earth signs are Capricorn, Taurus and Virgo. If these signs are anywhere in your chart, you claim Earth sign energy. Grounded and loyal, you thrive in stable environments. You value practicality and balance, are extremely hardworking and understand the value of time, tradition and quality. You have the essential ability to create a warm, safe and comforting place wherever you are. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Malachite, a deeply spiritual stone of transformation that helps cultivate a life filled with love, growth, and purpose. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211520262196",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-earth-element-necklace-31730652348468.gif?v=1720757001",
          link: "https://aweinspired.com/products/earth-element-necklace",
          product_block_id: "ecae2d891df20ba4080edbfbd69b7325a7d45e94",
          starting_price_formatted: "$252",
          tags: [],
          title: "Earth Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853813096500",
              price: 270,
              price_formatted: "$270",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853813129268",
              price: 252,
              price_formatted: "$252",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853825679412",
              price: 279,
              price_formatted: "$279",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853825712180",
              price: 261,
              price_formatted: "$261",
              title: "Earth Element Necklace",
            },
          ],
        },
        {
          description:
            "The Earth signs are Capricorn, Taurus and Virgo. If these signs are anywhere in your chart, you claim Earth sign energy. Grounded and loyal, you thrive in stable environments. You value practicality and balance, are extremely hardworking and understand the value of time, tradition and quality. You have the essential ability to create a warm, safe and comforting place wherever you are. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Malachite, a deeply spiritual stone of transformation that helps cultivate a life filled with love, growth, and purpose. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211445911604",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-earth-element-amulet-31737062326324.gif?v=1720755374",
          link: "https://aweinspired.com/products/earth-element-amulet",
          product_block_id: "ecae2d891df20ba4080edbfbd69b7325a7d45e94",
          starting_price_formatted: "$225",
          tags: [],
          title: "Earth Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41842765234228",
              price: 235,
              price_formatted: "$235",
              title: "Earth Element Amulet",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41842847907892",
              price: 225,
              price_formatted: "$225",
              title: "Earth Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "6530b2b35095647e1625273a9ab69cc319eacc2a",
      name: "Libra - Element",
      products: [
        {
          description:
            "The Air signs are Aquarius, Gemini and Libra. If these signs are anywhere in your chart, you claim Air sign energy. Adventurous, cool-headed and sociable, you are a seeker of truth and understand the value of analytical thinking and calm communication. You have the ability to understand ephemeral concepts with ease and flexibility. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with white Mother of Pearl, which is known to have deeply soothing, healing properties that protect the wearer from suffering negative energy. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211520524340",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-air-element-necklace-31730652184628.gif?v=1720639084",
          link: "https://aweinspired.com/products/air-element-necklace",
          product_block_id: "6530b2b35095647e1625273a9ab69cc319eacc2a",
          starting_price_formatted: "$252",
          tags: [],
          title: "Air Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853702307892",
              price: 270,
              price_formatted: "$270",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853702340660",
              price: 279,
              price_formatted: "$279",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853702373428",
              price: 252,
              price_formatted: "$252",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853702406196",
              price: 261,
              price_formatted: "$261",
              title: "Air Element Necklace",
            },
          ],
        },
        {
          description:
            "The Air signs are Aquarius, Gemini and Libra. If these signs are anywhere in your chart, you claim Air sign energy. Adventurous, cool-headed and sociable, you are a seeker of truth and understand the value of analytical thinking and calm communication. You have the ability to understand ephemeral concepts with ease and flexibility. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with white Mother of Pearl, which is known to have deeply soothing, healing properties that protect the wearer from suffering negative energy. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211446042676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-air-element-amulet-31737061736500.gif?v=1720638911",
          link: "https://aweinspired.com/products/air-element-amulet",
          product_block_id: "6530b2b35095647e1625273a9ab69cc319eacc2a",
          starting_price_formatted: "$225",
          tags: [],
          title: "Air Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832997257268",
              price: 225,
              price_formatted: "$225",
              title: "Air Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832997290036",
              price: 235,
              price_formatted: "$235",
              title: "Air Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "e5cd9045179bb7607e0e59ebbf6f21d0bf851c74",
      name: "Scorpio - Element",
      products: [
        {
          description:
            "The Water signs are Pisces, Cancer and Scorpio. If these signs are anywhere in your chart, you claim Water sign energy. Compassionate and sentimental, you run deep and have an imaginative, sensitive nature. You understand the power and meaning of your emotional responses. You have the ability of intuition, perceiving signs, symbols and subtle cues that others may miss. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Abalone, which is known to balance emotions, relieve anxiety and help to release negative emotions and replace them with love and self compassion. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211523964980",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-water-16-18-box-chain-element-necklace-31730652577844.gif?v=1720762411",
          link: "https://aweinspired.com/products/water-element-necklace",
          product_block_id: "e5cd9045179bb7607e0e59ebbf6f21d0bf851c74",
          starting_price_formatted: "$252",
          tags: [],
          title: "Water Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41832997027892",
              price: 252,
              price_formatted: "$252",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41832997060660",
              price: 270,
              price_formatted: "$270",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853977919540",
              price: 261,
              price_formatted: "$261",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853977952308",
              price: 279,
              price_formatted: "$279",
              title: "Water Element Necklace",
            },
          ],
        },
        {
          description:
            "The Water signs are Pisces, Cancer and Scorpio. If these signs are anywhere in your chart, you claim Water sign energy. Compassionate and sentimental, you run deep and have an imaginative, sensitive nature. You understand the power and meaning of your emotional responses. You have the ability of intuition, perceiving signs, symbols and subtle cues that others may miss. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Abalone, which is known to balance emotions, relieve anxiety and help to release negative emotions and replace them with love and self compassion. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211447550004",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-water-element-amulet-31737063374900.gif?v=1720652228",
          link: "https://aweinspired.com/products/water-element-amulet",
          product_block_id: "e5cd9045179bb7607e0e59ebbf6f21d0bf851c74",
          starting_price_formatted: "$225",
          tags: [],
          title: "Water Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832996634676",
              price: 225,
              price_formatted: "$225",
              title: "Water Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832996667444",
              price: 235,
              price_formatted: "$235",
              title: "Water Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "b32cfdb548a11420561ad0e139a26b2e9402ebe3",
      name: "Sagittarius - Element",
      products: [
        {
          description:
            "The Fire signs are Aries, Leo and Sagittarius. If these signs are anywhere in your chart, you claim Fire sign energy. Passionate and intense, your energy is high, dynamic and magnetizing. You value your freedom, command attention, and live life on your own terms above all. You have the powerful ability to regenerate no matter what may happen. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Carnelian, an energetic stone of passion, courage and strength. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211523833908",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-fire-16-18-box-chain-element-necklace-31730652479540.gif?v=1720758647",
          link: "https://aweinspired.com/products/fire-element-necklace",
          product_block_id: "b32cfdb548a11420561ad0e139a26b2e9402ebe3",
          starting_price_formatted: "$252",
          tags: [],
          title: "Fire Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853856219188",
              price: 270,
              price_formatted: "$270",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853856251956",
              price: 279,
              price_formatted: "$279",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853856284724",
              price: 252,
              price_formatted: "$252",
              title: "Fire Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853856317492",
              price: 261,
              price_formatted: "$261",
              title: "Fire Element Necklace",
            },
          ],
        },
        {
          description:
            "The Fire signs are Aries, Leo and Sagittarius. If these signs are anywhere in your chart, you claim Fire sign energy. Passionate and intense, your energy is high, dynamic and magnetizing. You value your freedom, command attention, and live life on your own terms above all. You have the powerful ability to regenerate no matter what may happen. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Carnelian, an energetic stone of passion, courage and strength. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211446173748",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-fire-element-amulet-31737062752308.gif?v=1720777696",
          link: "https://aweinspired.com/products/fire-element-amulet",
          product_block_id: "b32cfdb548a11420561ad0e139a26b2e9402ebe3",
          starting_price_formatted: "$225",
          tags: [],
          title: "Fire Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832998010932",
              price: 225,
              price_formatted: "$225",
              title: "Fire Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832998043700",
              price: 235,
              price_formatted: "$235",
              title: "Fire Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "97044b688c926ac13a1779203ac7ab8f604a108f",
      name: "Capricorn - Element",
      products: [
        {
          description:
            "The Earth signs are Capricorn, Taurus and Virgo. If these signs are anywhere in your chart, you claim Earth sign energy. Grounded and loyal, you thrive in stable environments. You value practicality and balance, are extremely hardworking and understand the value of time, tradition and quality. You have the essential ability to create a warm, safe and comforting place wherever you are. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Malachite, a deeply spiritual stone of transformation that helps cultivate a life filled with love, growth, and purpose. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211520262196",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-earth-element-necklace-31730652348468.gif?v=1720757001",
          link: "https://aweinspired.com/products/earth-element-necklace",
          product_block_id: "97044b688c926ac13a1779203ac7ab8f604a108f",
          starting_price_formatted: "$252",
          tags: [],
          title: "Earth Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853813096500",
              price: 270,
              price_formatted: "$270",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853813129268",
              price: 252,
              price_formatted: "$252",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853825679412",
              price: 279,
              price_formatted: "$279",
              title: "Earth Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853825712180",
              price: 261,
              price_formatted: "$261",
              title: "Earth Element Necklace",
            },
          ],
        },
        {
          description:
            "The Earth signs are Capricorn, Taurus and Virgo. If these signs are anywhere in your chart, you claim Earth sign energy. Grounded and loyal, you thrive in stable environments. You value practicality and balance, are extremely hardworking and understand the value of time, tradition and quality. You have the essential ability to create a warm, safe and comforting place wherever you are. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Malachite, a deeply spiritual stone of transformation that helps cultivate a life filled with love, growth, and purpose. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211445911604",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-earth-element-amulet-31737062326324.gif?v=1720755374",
          link: "https://aweinspired.com/products/earth-element-amulet",
          product_block_id: "97044b688c926ac13a1779203ac7ab8f604a108f",
          starting_price_formatted: "$225",
          tags: [],
          title: "Earth Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41842765234228",
              price: 235,
              price_formatted: "$235",
              title: "Earth Element Amulet",
            },
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41842847907892",
              price: 225,
              price_formatted: "$225",
              title: "Earth Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "9d85d11be917b073ba9707fa35014ad67db557cc",
      name: "Aquarius - Element",
      products: [
        {
          description:
            "The Air signs are Aquarius, Gemini and Libra. If these signs are anywhere in your chart, you claim Air sign energy. Adventurous, cool-headed and sociable, you are a seeker of truth and understand the value of analytical thinking and calm communication. You have the ability to understand ephemeral concepts with ease and flexibility. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with white Mother of Pearl, which is known to have deeply soothing, healing properties that protect the wearer from suffering negative energy. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211520524340",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-16-18-air-element-necklace-31730652184628.gif?v=1720639084",
          link: "https://aweinspired.com/products/air-element-necklace",
          product_block_id: "9d85d11be917b073ba9707fa35014ad67db557cc",
          starting_price_formatted: "$252",
          tags: [],
          title: "Air Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41853702307892",
              price: 270,
              price_formatted: "$270",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853702340660",
              price: 279,
              price_formatted: "$279",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41853702373428",
              price: 252,
              price_formatted: "$252",
              title: "Air Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853702406196",
              price: 261,
              price_formatted: "$261",
              title: "Air Element Necklace",
            },
          ],
        },
        {
          description:
            "The Air signs are Aquarius, Gemini and Libra. If these signs are anywhere in your chart, you claim Air sign energy. Adventurous, cool-headed and sociable, you are a seeker of truth and understand the value of analytical thinking and calm communication. You have the ability to understand ephemeral concepts with ease and flexibility. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with white Mother of Pearl, which is known to have deeply soothing, healing properties that protect the wearer from suffering negative energy. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211446042676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-air-element-amulet-31737061736500.gif?v=1720638911",
          link: "https://aweinspired.com/products/air-element-amulet",
          product_block_id: "9d85d11be917b073ba9707fa35014ad67db557cc",
          starting_price_formatted: "$225",
          tags: [],
          title: "Air Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832997257268",
              price: 225,
              price_formatted: "$225",
              title: "Air Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832997290036",
              price: 235,
              price_formatted: "$235",
              title: "Air Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "e099c8dfeb097d4a5b98e25849e9eac6b3f44506",
      name: "Pisces - Element",
      products: [
        {
          description:
            "The Water signs are Pisces, Cancer and Scorpio. If these signs are anywhere in your chart, you claim Water sign energy. Compassionate and sentimental, you run deep and have an imaginative, sensitive nature. You understand the power and meaning of your emotional responses. You have the ability of intuition, perceiving signs, symbols and subtle cues that others may miss. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Abalone, which is known to balance emotions, relieve anxiety and help to release negative emotions and replace them with love and self compassion. In this set, the amulet is paired with a stunning box chain in your choice of length. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$279",
          id: "7211523964980",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-water-16-18-box-chain-element-necklace-31730652577844.gif?v=1720762411",
          link: "https://aweinspired.com/products/water-element-necklace",
          product_block_id: "e099c8dfeb097d4a5b98e25849e9eac6b3f44506",
          starting_price_formatted: "$252",
          tags: [],
          title: "Water Element Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 252,
              compare_at_price_formatted: null,
              id: "41832997027892",
              price: 252,
              price_formatted: "$252",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 270,
              compare_at_price_formatted: null,
              id: "41832997060660",
              price: 270,
              price_formatted: "$270",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 261,
              compare_at_price_formatted: null,
              id: "41853977919540",
              price: 261,
              price_formatted: "$261",
              title: "Water Element Necklace",
            },
            {
              compare_at_price: 279,
              compare_at_price_formatted: null,
              id: "41853977952308",
              price: 279,
              price_formatted: "$279",
              title: "Water Element Necklace",
            },
          ],
        },
        {
          description:
            "The Water signs are Pisces, Cancer and Scorpio. If these signs are anywhere in your chart, you claim Water sign energy. Compassionate and sentimental, you run deep and have an imaginative, sensitive nature. You understand the power and meaning of your emotional responses. You have the ability of intuition, perceiving signs, symbols and subtle cues that others may miss. This double-sided spinner amulet is hinged so that it is fully dynamic, meaning that it spins smoothly and can be worn on either side, and is inlaid with Abalone, which is known to balance emotions, relieve anxiety and help to release negative emotions and replace them with love and self compassion. <br><br> When you put on your pendant, your Element symbol should be facing upright on the back, where it rests against your skin. Because of the dynamic spinning nature of these pendants, you may notice your Element to appear upside down when you put it on. To fix, simply remove, flip and put it back on the reverse way, and it will be right side up.",
          ending_price_formatted: "$235",
          id: "7211447550004",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-pendants-14k-yellow-gold-vermeil-large-water-element-amulet-31737063374900.gif?v=1720652228",
          link: "https://aweinspired.com/products/water-element-amulet",
          product_block_id: "e099c8dfeb097d4a5b98e25849e9eac6b3f44506",
          starting_price_formatted: "$225",
          tags: [],
          title: "Water Element Amulet",
          type: "Pendants",
          variants: [
            {
              compare_at_price: 225,
              compare_at_price_formatted: null,
              id: "41832996634676",
              price: 225,
              price_formatted: "$225",
              title: "Water Element Amulet",
            },
            {
              compare_at_price: 235,
              compare_at_price_formatted: null,
              id: "41832996667444",
              price: 235,
              price_formatted: "$235",
              title: "Water Element Amulet",
            },
          ],
        },
      ],
    },
    {
      id: "634188646fe2b164b93e899bee7a12cd4975a212",
      name: "Aries - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "634188646fe2b164b93e899bee7a12cd4975a212",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "634188646fe2b164b93e899bee7a12cd4975a212",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "5e053a39620c12817c1da83114a46eb80db9cd8a",
      name: "Taurus - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "5e053a39620c12817c1da83114a46eb80db9cd8a",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "5e053a39620c12817c1da83114a46eb80db9cd8a",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "475c26404c28d9f7675b22f1899cb90d9d31651b",
      name: "Gemini - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "475c26404c28d9f7675b22f1899cb90d9d31651b",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "475c26404c28d9f7675b22f1899cb90d9d31651b",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "ba1b260fa8e82e6013137d8095ee858c54758a3d",
      name: "Cancer - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "ba1b260fa8e82e6013137d8095ee858c54758a3d",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "ba1b260fa8e82e6013137d8095ee858c54758a3d",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "de49d67983033d1fae102c703fad019311037819",
      name: "Leo - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "de49d67983033d1fae102c703fad019311037819",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "de49d67983033d1fae102c703fad019311037819",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "e926652e03d8d3f9520be2872806089dacfdcd1d",
      name: "Virgo - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "e926652e03d8d3f9520be2872806089dacfdcd1d",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "e926652e03d8d3f9520be2872806089dacfdcd1d",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "ec3b878bf6dd75d6b84560e11a64fc00be6c77dc",
      name: "Libra - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "ec3b878bf6dd75d6b84560e11a64fc00be6c77dc",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "ec3b878bf6dd75d6b84560e11a64fc00be6c77dc",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "445589f5f59c66cf97cc11d92a07730ef42976d6",
      name: "Scorpio - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "445589f5f59c66cf97cc11d92a07730ef42976d6",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "445589f5f59c66cf97cc11d92a07730ef42976d6",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "d4a97bcfc528ac7da015fe7e5a08f17317c1fafa",
      name: "Sagittarius - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "d4a97bcfc528ac7da015fe7e5a08f17317c1fafa",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "d4a97bcfc528ac7da015fe7e5a08f17317c1fafa",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "9e856db9f9c2d5aa709d3d62493dd40bc7b15c90",
      name: "Capricorn - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "9e856db9f9c2d5aa709d3d62493dd40bc7b15c90",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "9e856db9f9c2d5aa709d3d62493dd40bc7b15c90",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "b10ff7ff69ec08f62fade40af52bde7a355ecec4",
      name: "Aquarius - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "b10ff7ff69ec08f62fade40af52bde7a355ecec4",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "b10ff7ff69ec08f62fade40af52bde7a355ecec4",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "e394326f0e3cf88292aa1f0c30049219e37fe1aa",
      name: "Pisces - Sun Sign",
      products: [
        {
          description:
            "<p>A double-sided oval pendant celebrating your divine femininity and mystical connection to the stars. One pendant side features a celestial Goddess, the other features her corresponding constellation.</p>",
          ending_price_formatted: "$95",
          id: "7173367562292",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-zodiac-goddess-necklace-30964573569076.webp?v=1720649710",
          link: "https://aweinspired.com/products/zodiac-goddess-necklace",
          product_block_id: "e394326f0e3cf88292aa1f0c30049219e37fe1aa",
          starting_price_formatted: "$86",
          tags: [],
          title: "Zodiac Goddess Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 160,
              compare_at_price_formatted: null,
              id: "41357195575348",
              price: 95,
              price_formatted: "$95",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195804724",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195837492",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195870260",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195903028",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195935796",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357195968564",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196001332",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196034100",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196066868",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196099636",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196132404",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
            {
              compare_at_price: 145,
              compare_at_price_formatted: null,
              id: "41357196165172",
              price: 86,
              price_formatted: "$86",
              title: "Zodiac Goddess Necklace",
            },
          ],
        },
        {
          description:
            '<p data-mce-fragment="1">Honor and strengthen your connection to the higher celestial realms with our Zodiac Gemstone Amulet. Each carefully set gemstone resonates powerful universal energy with your zodiac symbol and sparkles like the stars themselves. Add your sun, moon and rising or your partner\'s sign to your collection for a new dimension of astrological magic.<br></p>',
          ending_price_formatted: "$130",
          id: "7175140671540",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-aquarius-mini-zodiac-gemstone-necklace-31191585423412.webp?v=1720659062",
          link: "https://aweinspired.com/products/zodiac-gemstone-necklace",
          product_block_id: "e394326f0e3cf88292aa1f0c30049219e37fe1aa",
          starting_price_formatted: "$115",
          tags: [],
          title: "Zodiac Gemstone Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567813172",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567845940",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567878708",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567911476",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567944244",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366567977012",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568009780",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568042548",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568075316",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568108084",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568140852",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 130,
              compare_at_price_formatted: null,
              id: "41366568173620",
              price: 130,
              price_formatted: "$130",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568206388",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568239156",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568271924",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568304692",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568337460",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568370228",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568402996",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568435764",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568468532",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568501300",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568534068",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
            {
              compare_at_price: 115,
              compare_at_price_formatted: null,
              id: "41366568566836",
              price: 115,
              price_formatted: "$115",
              title: "Zodiac Gemstone Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "679f9c90717c0afd14ce7b690c86046313d314ad",
      name: "Affirmation - Inhale the Future, Exhale the Past",
      products: [
        {
          description:
            '<p>Your personal affirmation is a mantra that inspires you to be your best self. The Awe Community selected their favorite affirmations, which we’ve spelled out in 14k yellow gold vermeil letters that link to form a timeless chain bracelet. Wear your empowering mantra and live your life by its message.</p>\n<p><br data-mce-fragment="1">Each Affirmation Necklace comes with a corresponding decal of your chosen Affirmation for you to put on your mirror and consider every morning as you adorn yourself. Call it your Affirmation Ritual.</p>',
          ending_price_formatted: "$221",
          id: "7184248602676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-i-am-worthy-of-abundance-affirmation-necklace-31997528965172.webp?v=1720475101",
          link: "https://aweinspired.com/products/everything-i-need-is-within-me-necklace",
          product_block_id: "679f9c90717c0afd14ce7b690c86046313d314ad",
          starting_price_formatted: "$184",
          tags: [],
          title: "Affirmation Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588394036",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588426804",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588459572",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588492340",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588525108",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588557876",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588623412",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588656180",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588688948",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588721716",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588754484",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588787252",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588820020",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "43587136192564",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "4db040cbe412cc8d08b5f05570155414d7b4beb5",
      name: "Affirmation - Everything I need is Within Me",
      products: [
        {
          description:
            '<p>Your personal affirmation is a mantra that inspires you to be your best self. The Awe Community selected their favorite affirmations, which we’ve spelled out in 14k yellow gold vermeil letters that link to form a timeless chain bracelet. Wear your empowering mantra and live your life by its message.</p>\n<p><br data-mce-fragment="1">Each Affirmation Necklace comes with a corresponding decal of your chosen Affirmation for you to put on your mirror and consider every morning as you adorn yourself. Call it your Affirmation Ritual.</p>',
          ending_price_formatted: "$221",
          id: "7184248602676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-i-am-worthy-of-abundance-affirmation-necklace-31997528965172.webp?v=1720475101",
          link: "https://aweinspired.com/products/everything-i-need-is-within-me-necklace",
          product_block_id: "4db040cbe412cc8d08b5f05570155414d7b4beb5",
          starting_price_formatted: "$184",
          tags: [],
          title: "Affirmation Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588394036",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588426804",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588459572",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588492340",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588525108",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588557876",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588623412",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588656180",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588688948",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588721716",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588754484",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588787252",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588820020",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "43587136192564",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "93570e970b80cec71d391041ae636adc950c4786",
      name: "Affirmation - Say Yes to New Adventures",
      products: [
        {
          description:
            '<p>Your personal affirmation is a mantra that inspires you to be your best self. The Awe Community selected their favorite affirmations, which we’ve spelled out in 14k yellow gold vermeil letters that link to form a timeless chain bracelet. Wear your empowering mantra and live your life by its message.</p>\n<p><br data-mce-fragment="1">Each Affirmation Necklace comes with a corresponding decal of your chosen Affirmation for you to put on your mirror and consider every morning as you adorn yourself. Call it your Affirmation Ritual.</p>',
          ending_price_formatted: "$221",
          id: "7184248602676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-i-am-worthy-of-abundance-affirmation-necklace-31997528965172.webp?v=1720475101",
          link: "https://aweinspired.com/products/everything-i-need-is-within-me-necklace",
          product_block_id: "93570e970b80cec71d391041ae636adc950c4786",
          starting_price_formatted: "$184",
          tags: [],
          title: "Affirmation Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588394036",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588426804",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588459572",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588492340",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588525108",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588557876",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588623412",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588656180",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588688948",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588721716",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588754484",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588787252",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588820020",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "43587136192564",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "703d1474da3c2a055f63013459bd5a1f74106dc9",
      name: "Affirmation - Purpose Over Perfect",
      products: [
        {
          description:
            '<p>Your personal affirmation is a mantra that inspires you to be your best self. The Awe Community selected their favorite affirmations, which we’ve spelled out in 14k yellow gold vermeil letters that link to form a timeless chain bracelet. Wear your empowering mantra and live your life by its message.</p>\n<p><br data-mce-fragment="1">Each Affirmation Necklace comes with a corresponding decal of your chosen Affirmation for you to put on your mirror and consider every morning as you adorn yourself. Call it your Affirmation Ritual.</p>',
          ending_price_formatted: "$221",
          id: "7184248602676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-i-am-worthy-of-abundance-affirmation-necklace-31997528965172.webp?v=1720475101",
          link: "https://aweinspired.com/products/everything-i-need-is-within-me-necklace",
          product_block_id: "703d1474da3c2a055f63013459bd5a1f74106dc9",
          starting_price_formatted: "$184",
          tags: [],
          title: "Affirmation Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588394036",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588426804",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588459572",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588492340",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588525108",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588557876",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588623412",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588656180",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588688948",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588721716",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588754484",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588787252",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588820020",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "43587136192564",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
          ],
        },
      ],
    },
    {
      id: "76e73eb33792c5819073b7e193be1377b9170833",
      name: "Affirmation - I Am Worthy of Abundance",
      products: [
        {
          description:
            '<p>Your personal affirmation is a mantra that inspires you to be your best self. The Awe Community selected their favorite affirmations, which we’ve spelled out in 14k yellow gold vermeil letters that link to form a timeless chain bracelet. Wear your empowering mantra and live your life by its message.</p>\n<p><br data-mce-fragment="1">Each Affirmation Necklace comes with a corresponding decal of your chosen Affirmation for you to put on your mirror and consider every morning as you adorn yourself. Call it your Affirmation Ritual.</p>',
          ending_price_formatted: "$221",
          id: "7184248602676",
          image:
            "https://cdn.shopify.com/s/files/1/0077/9894/7892/files/awe-inspired-necklaces-14k-yellow-gold-vermeil-i-am-worthy-of-abundance-affirmation-necklace-31997528965172.webp?v=1720475101",
          link: "https://aweinspired.com/products/everything-i-need-is-within-me-necklace",
          product_block_id: "76e73eb33792c5819073b7e193be1377b9170833",
          starting_price_formatted: "$184",
          tags: [],
          title: "Affirmation Necklace",
          type: "Necklaces",
          variants: [
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588394036",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588426804",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588459572",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588492340",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588525108",
              price: 199,
              price_formatted: "$199",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "41397588557876",
              price: 221,
              price_formatted: "$221",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588623412",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588656180",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588688948",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588721716",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588754484",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588787252",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 240,
              compare_at_price_formatted: null,
              id: "41397588820020",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
            {
              compare_at_price: 260,
              compare_at_price_formatted: null,
              id: "43587136192564",
              price: 184,
              price_formatted: "$184",
              title: "Affirmation Necklace",
            },
          ],
        },
      ],
    },
  ],
};


const metadataJson = {
  sections: [
    {
      id: "f35b05ada15c9662015bcfda495bd3f1a5377748",
      name: "Aphrodite",
      metadata: {
        image: "https://bethecozy.com/cdn/shop/t/1/assets/lilith.svg?v=20600633332720394311721237674",
        title: "Aphrodite",
        description: "Joyful, kind, a true romantic. You are light hearted, love to laugh, and can be known to cause a little mischief.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "bb4af6b396550fda975942593a3c0ecec6df8c53",
      name: "Athena",
      metadata: {
        image: "https://bethecozy.com/cdn/shop/t/1/assets/lilith.svg?v=20600633332720394311721237674",
        title: "Athena",
        description: "Rational, strong, and always in pursuit of greatness. You have internal wisdom that guides your decision making.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "d509625321dd0b5a36912032a3911afadb0453f3",
      name: "Freya",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Freya",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "a2fd72c240e2713ddb9da35acdb9bcc767724a44",
      name: "Hecate",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Hecate",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "606793a89ca08d47ff7bf5d3cc5804af16e4a28c",
      name: "Isis",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Isis",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "37d55f207e16f14c73fa679fb2f8e789a3d3aa30",
      name: "Lilith",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lilith",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "7bb2152395e335c5f7ef7e251c3fef57086d915e",
      name: "Medusa",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Medusa",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "c6e2aa57d229ee12384fae582310bd82ef417ab2",
      name: "Persephone",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Persephone",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "48418164b021d3a92b1fce45cc7a8ae7451db5ef",
      name: "Mother Earth",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Mother Earth",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "8c8548ec2edf3a0826443a4b8c32b0814405b687",
      name: "Selene",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Selene",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "a7fcfbb47c65e299f5374d60cfc6e676a9f1a53c",
      name: "Brigid",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Brigid",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "32a0c0388bf674710a29b2570f70ac47f8525c0e",
      name: "The Morrigan",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "The Morrigan",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "09437606ac4b6a3e5a8704659c1dbeb2d3591daf",
      name: "Bastet",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Bastet",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "01650319b7b2d5939b6a57365e491c5b6c7f325a",
      name: "Guadalupe",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Guadalupe",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "643638b5c06f3451a48a0fa41ee5673721a96263",
      name: "Asteria - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Asteria",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "23d9b77db05b5fdcf2e76b2407be8bcb4eec68f8",
      name: "Psyche - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Psyche",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "283bed443d21d5d14e958b85a383e6e5da2f739a",
      name: "Lady Buddha - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lady Buddha",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "2537c3935383d1106779c22e124140e5c5ae348d",
      name: "Rhiannon",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Rhiannon",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "b31eaae76601630d64376b446461e84617d14197",
      name: "Oshun",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Oshun",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "17e59da6591260af30bd452fe8d8253f62450190",
      name: "Nemesis",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Nemesis",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ba1c16195aa64a06097a9d4e3391de9545d8e7a5",
      name: "Hermaphroditus",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Hermaphroditus",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ca6e1bad2e79bf08520a4d90096b77d6623838df",
      name: "Fortuna",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Fortuna",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "d02844324b75e29a7bc7e0940ecb5a61651b36fd",
      name: "Artemis",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Artemis",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "4236dca6523a0ec5efc6d395ae99b179b9ebb6c1",
      name: "Lakshmi - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lakshmi",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "56850b4b9db04699ac223aa8bacaff2c05e27629",
      name: "Joan of Arc",
      metadata: {
        image: "https://bethecozy.com/cdn/shop/t/1/assets/lilith.svg?v=20600633332720394311721237674",
        title: "Joan of Arc",
        description: "Your inner voice is the divine shining light on your path to greatness. Your wholehearted idealism and fighting spirit define you.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "afeb9ce351eda05a987e6b6fbd836de648aa8331",
      name: "Harriet Tubman",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Harriet Tubman",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "0e61fc2a6265133ede6605a35061940983ef2c01",
      name: "Cleopatra",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Cleopatra",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "b89ba32ec8c6111f9027c94be7bd28360ac74ad0",
      name: "Mulan",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Mulan",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "b4aa9c90f1e6724302fd2d7178c202bedb0601a7",
      name: "Frida Kahlo",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Frida Kahlo",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "5f63df51dc93c256602e4515d243ebfd0ebe1e68",
      name: "RBG",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "RBG",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "53c18ba23874461432d559b832728e5c76c37ef4",
      name: "Florence Nightingale",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Florence Nightingale",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "db85ac7514c2a1e0dbe04cf56429034a33e7c939",
      name: "Mother Mary",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Mother Mary",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "77f67a15be1f201e111b7cde5a2ad9feadaf6e77",
      name: "Marsha P Johnson",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Marsha P Johnson",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "cba93a01faee8b8e113b63f9ec7a48fa5eecbeb2",
      name: "Marie Curie",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Marie Curie",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "630182eab780af6100ce992c55997f118ce829bb",
      name: "Sappho",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Sappho",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "6d5faf1173bcb8e51f24dfd8d2fd9bfb1290c7ce",
      name: "111",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "New opportunities are near. Trust your instincts and stay positive; your desires align with the universe. Make a wish and set things in motion.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "401d354d4357f729801b87d40fe9d1aed9d57789",
      name: "222",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Sign of balance and harmony. You're on the right path. Reach out to a trusted companion; your desires align in a higher realm.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "964bcb181aeb655888b9812a2c4f2bcc16dddb63",
      name: "333",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Time for creativity and positive energy. Your optimism attracts abundance and joy. Embrace your creative muse and accept the universe's gifts.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "dd9f87a8569de270cd20014dc1939407e4b380b9",
      name: "444",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Sign of stability and empowerment. Take responsibility for your actions. Divine guardians support you in building a safe, solid foundation.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "7f3dfff926f47b7554cac4298c5de74015ed2b91",
      name: "555",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Indicates significant personal growth and change. Embrace transformations aligned with your spiritual wellbeing to achieve your highest self.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "c18678de3ae46a289123719349eaa9e4a3e555a7",
      name: "666",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Encourages introspection and self-discovery. Seek balance, practice solitude, and show compassion to yourself and others.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "64d9faaa6c2fa3d2bc88f6a144847cf68ba66606",
      name: "777",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Highly spiritual number linked to luck and divine guidance. Your efforts align with the universe, enhancing your manifestation abilities.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "92ddf5fb6e269d442cec5e0ad802ad6f9668b5e2",
      name: "888",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Symbol of abundance and manifestation. Financial and material efforts harmonize, leading to prosperity. Opportunities are becoming available.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "65faa022b1c79b57bbba96e8653d3b815b4c70d2",
      name: "999",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "NEW BEGINNINGS. WISHES GRANTED. INTUITION.",
        description: "Marks the completion of a cycle. Release old habits for renewal and new opportunities. Embrace change. The universe nudges you toward freedom.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "f53887cbec5ed155f0b536f7ef58b1ce32919fcc",
      name: "Gate of Hades",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Gate of Hades",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "c9e7cc38940c3b48b27dce608e97b268f62bdd23",
      name: "Woman Power",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Woman Power",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "4c80cf35ac0dc8bdb0226d5a42dc517cd043ec76",
      name: "Spiked Heart",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Spiked Heart",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "fd98bce9793ce8e699a3f08b11d6357d6cf54e9d",
      name: "Opal Sun",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Opal Sun",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "dc98eee769e21ea9e3f7681c96a3b2973f11eb76",
      name: "Diamond Moon Wave",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Diamond Moon Wave",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ae986b4fc3cceaebf680a9f8c2bd5c02067dde8f",
      name: "Triple Moon",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Triple Moon",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "de96671aab57aa95771aa4da7dd6ac5a0afdcb99",
      name: "Diamond Sword",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Diamond Sword",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "8e78d7a72411a0c20de48dd2f4f8ab869375a882",
      name: "Crescent Snake Eye",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Crescent Snake Eye",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "1329d8a30161c9bfe08c5d34f051300a9e912d24",
      name: "Magic Mushroom",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Magic Mushroom",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ab0ee43c50f9949e7c92e327f22c1e18a3c80ddc",
      name: "Pomegranate",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Pomegranate",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "02e88250403999406ccf22978645d03afde9759a",
      name: "Magical Cat",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Magical Cat",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "975a74f57ec9e9be12bb452a1eb83db37c4ddf18",
      name: "Lucky Dragonfly",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lucky Dragonfly",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "c01a03832d4a9d15e4d98437f85a02bcc9437a85",
      name: "Red - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Red",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ae69d736482f74f977f42db08a4328260f7b8655",
      name: "Orange - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Orange",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "6717af620e63495e9bc8a96ca341938c7bb890ae",
      name: "Yellow - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Yellow",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ff5e0b66467ac107b34f422a913173e12489cca7",
      name: "Green - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Green",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "34426562048c44a4b75814e28ddedcfc073bbfc2",
      name: "Blue - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Blue",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "9e0b6407e74ad3db14608e10396e8861c127da44",
      name: "Indigo - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Indigo",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "b937e1db93d95bdd8447b298107d3a1d7cc9f440",
      name: "Violet - NO PRODUCT",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Violet",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "9a198d2c6ad9577e75fe653841b01b7de93e97a5",
      name: "Aries - Element",
      metadata: {
        image: "https://bethecozy.com/cdn/shop/t/1/assets/fire-element.svg?v=94642894488556228311721237881",
        title: "Fire",
        description: "Passionate and intense, your energy is dynamic and magnetizing. You value freedom, command attention, and live on your own terms.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "1c1b7cc75752574fa00e448b4518139730716f60",
      name: "Taurus - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Earth",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "c0fab9e8126715376b2f2359983b75fb563b4736",
      name: "Gemini - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Air",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "e1528d84e25b134f3113d892904e07cb47387871",
      name: "Cancer - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Water",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "6808a15a634f19f9bf2c56183124a8ee48690a0e",
      name: "Leo - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Fire",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ecae2d891df20ba4080edbfbd69b7325a7d45e94",
      name: "Virgo - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Earth",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "6530b2b35095647e1625273a9ab69cc319eacc2a",
      name: "Libra - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Air",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "e5cd9045179bb7607e0e59ebbf6f21d0bf851c74",
      name: "Scorpio - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Water",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "b32cfdb548a11420561ad0e139a26b2e9402ebe3",
      name: "Sagittarius - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Fire",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "97044b688c926ac13a1779203ac7ab8f604a108f",
      name: "Capricorn - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Earth",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "9d85d11be917b073ba9707fa35014ad67db557cc",
      name: "Aquarius - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Air",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "e099c8dfeb097d4a5b98e25849e9eac6b3f44506",
      name: "Pisces - Element",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Water",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "634188646fe2b164b93e899bee7a12cd4975a212",
      name: "Aries - Sun Sign",
      metadata: {
        image: "https://bethecozy.com/cdn/shop/t/1/assets/libra-sign.svg?v=112449688833176501021721237865",
        title: "Aries",
        description: "Your sun is in Aries, which means you have the spark of a Fire sign. Your strong intuition keeps you on the right path as you navigate your way through life.",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "5e053a39620c12817c1da83114a46eb80db9cd8a",
      name: "Taurus - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Taurus",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "475c26404c28d9f7675b22f1899cb90d9d31651b",
      name: "Gemini - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Gemini",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ba1b260fa8e82e6013137d8095ee858c54758a3d",
      name: "Cancer - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lorem Ipsum Title",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "de49d67983033d1fae102c703fad019311037819",
      name: "Leo - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Cancer",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "e926652e03d8d3f9520be2872806089dacfdcd1d",
      name: "Virgo - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Virgo",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "ec3b878bf6dd75d6b84560e11a64fc00be6c77dc",
      name: "Libra - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Libra",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "445589f5f59c66cf97cc11d92a07730ef42976d6",
      name: "Scorpio - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Scorpio",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "d4a97bcfc528ac7da015fe7e5a08f17317c1fafa",
      name: "Sagittarius - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Sagittarius",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "9e856db9f9c2d5aa709d3d62493dd40bc7b15c90",
      name: "Capricorn - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Capricorn",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "b10ff7ff69ec08f62fade40af52bde7a355ecec4",
      name: "Aquarius - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Aquarius",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "e394326f0e3cf88292aa1f0c30049219e37fe1aa",
      name: "Pisces - Sun Sign",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Pisces",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "679f9c90717c0afd14ce7b690c86046313d314ad",
      name: "Affirmation - Inhale the Future, Exhale the Past",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lorem Ipsum Title",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "4db040cbe412cc8d08b5f05570155414d7b4beb5",
      name: "Affirmation - Everything I need is Within Me",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lorem Ipsum Title",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "93570e970b80cec71d391041ae636adc950c4786",
      name: "Affirmation - Say Yes to New Adventures",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lorem Ipsum Title",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "703d1474da3c2a055f63013459bd5a1f74106dc9",
      name: "Affirmation - Purpose Over Perfect",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lorem Ipsum Title",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
    {
      id: "76e73eb33792c5819073b7e193be1377b9170833",
      name: "Affirmation - I Am Worthy of Abundance",
      metadata: {
        image: "https://via.placeholder.com/150",
        title: "Lorem Ipsum Title",
        description: "Lorem Ipsum Description",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        product_description: "Lorem ipsum product",
      },
    },
  ],
};

